import * as i0 from '@angular/core';
import { Component, Inject, Injectable, forwardRef, Directive, Input, ViewChild, EventEmitter, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i24 from '@angular/flex-layout/flex';
import { isNil, noop, isEmpty, isNumber, isString, get, find, assignIn, omit, cloneDeep, findIndex, chain, set, isNull, size, pullAt, has, includes, forEach, replace, concat, remove, reduce, assign } from 'lodash';
import * as i2$1 from '@angular/forms';
import { NG_ASYNC_VALIDATORS, NgForm, FormsModule } from '@angular/forms';
import * as i26 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import * as i1$2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@angular/common/http';
import { HttpRequest, HttpEventType, HttpClientModule } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { BehaviorSubject, of, Subject, throwError, isObservable } from 'rxjs';
import { map, tap, filter, catchError } from 'rxjs/operators';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@angular/material/snack-bar';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import * as i1$3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3$1 from '@angular/material/core';
import { MatRippleModule, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as i8 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i9 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i5 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i11 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i12 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i1$4 from '@angular/material/icon';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import * as i14 from '@angular/material/form-field';
import * as i15 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i16 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i17 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i18 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i19 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i20 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i21 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i22 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i23 from '@angular/material/tooltip';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import * as i15$1 from '@angular/flex-layout/extended';
import * as i27 from 'ng-busy';
import { NgBusyModule } from 'ng-busy';
import * as i28 from 'angular-file';
import { ngfModule } from 'angular-file';
import * as moment from 'moment';
import * as i12$1 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as i4$1 from '@angular/material-moment-adapter';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
function FormSetupComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵtwoWayListener("filesChange", function FormSetupComponent_button_7_Template_button_filesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r13.files, $event) || (ctx_r13.files = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("filesChange", function FormSetupComponent_button_7_Template_button_filesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.handleImport($event));
    });
    i0.ɵɵelement(1, "mat-icon", 38)(2, "span", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("files", ctx_r0.files);
  }
}
function FormSetupComponent_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelement(1, "mat-icon", 41)(2, "span", 42);
    i0.ɵɵelementEnd();
  }
}
function FormSetupComponent_button_21_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 45);
  }
}
function FormSetupComponent_button_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function FormSetupComponent_button_21_Template_button_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r19);
      const item_r16 = restoredCtx.$implicit;
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.selectItem(item_r16));
    });
    i0.ɵɵelement(1, "mat-icon", 4);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormSetupComponent_button_21_mat_icon_4_Template, 1, 0, "mat-icon", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", (item_r16 == null ? null : item_r16.id) === (ctx_r2.model == null ? null : ctx_r2.model.id));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r16 == null ? null : item_r16.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (item_r16 == null ? null : item_r16.id) === (ctx_r2.model == null ? null : ctx_r2.model.id));
  }
}
function FormSetupComponent_mat_error_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 46);
  }
}
function FormSetupComponent_ng_container_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FormSetupComponent_ng_container_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FormSetupComponent_button_42_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function FormSetupComponent_button_42_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.deleteModel());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.delete"));
  }
}
function FormSetupComponent_button_43_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function FormSetupComponent_button_43_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.exportModel());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 50);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.export"));
  }
}
function FormSetupComponent_button_44_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function FormSetupComponent_button_44_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.duplicateModel());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.duplicate"));
  }
}
function FormSetupComponent_ng_template_54_div_1_mat_hint_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 85);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "form.name_not_unique"));
  }
}
function FormSetupComponent_ng_template_54_div_1_button_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_button_25_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r37);
      const blockIdx_r29 = i0.ɵɵnextContext().index;
      const ctx_r36 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView((ctx_r36.hiddenBlocks["block_" + blockIdx_r29] = false));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 86);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.expand"));
  }
}
function FormSetupComponent_ng_template_54_div_1_button_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_button_26_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r40);
      const blockIdx_r29 = i0.ɵɵnextContext().index;
      const ctx_r39 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView((ctx_r39.hiddenBlocks["block_" + blockIdx_r29] = true));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 87);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.collapse"));
  }
}
function FormSetupComponent_ng_template_54_div_1_button_43_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 88);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_button_43_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r44);
      const blockIdx_r29 = i0.ɵɵnextContext().index;
      const ctx_r42 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r42.removeBlock(blockIdx_r29));
    });
    i0.ɵɵelement(1, "mat-icon", 89)(2, "span", 90);
    i0.ɵɵelementEnd();
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_hint_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 85);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "form.name_not_unique"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_option_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 108);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const t_r57 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r57);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "form." + t_r57), " ");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_16_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r69);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.options["suffix"], $event) || (f_r46.options["suffix"] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", f_r46.options["suffix"]);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 2, "form.suffix"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "input", 122);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_17_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.options["decimals"], $event) || (f_r46.options["decimals"] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", f_r46.options["decimals"]);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 2, "form.decimals"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_18_mat_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 108);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r76 = ctx.$implicit;
    i0.ɵɵproperty("value", m_r76);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", m_r76.name, " ");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6);
    i0.ɵɵelement(1, "label", 123);
    i0.ɵɵelementStart(2, "mat-select", 99);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_18_Template_mat_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r79);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.options.measurement, $event) || (f_r46.options.measurement = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(3, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_18_mat_option_3_Template, 2, 2, "mat-option", 124);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r60 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.options.measurement);
    i0.ɵɵproperty("compareWith", ctx_r60.compareCondition);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r60.measurements)("ngForTrackBy", ctx_r60.trackByFn);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 125)(1, "mat-form-field", 58)(2, "input", 122);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_19_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r83);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.value, $event) || (f_r46.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.value);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 2, "form.default_value"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 128)(1, "input", 130);
    i0.ɵɵlistener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_mat_form_field_1_Template_input_ngModelChange_1_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r90);
      const oIdx_r87 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r88 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r88.optionChanged(f_r46["options"], $event, oIdx_r87));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 131);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_mat_form_field_1_Template_button_click_2_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r90);
      const oIdx_r87 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r91 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r91.removeOption(f_r46, oIdx_r87));
    });
    i0.ɵɵelement(3, "mat-icon", 132);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const o_r86 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", o_r86);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵtemplate(1, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_mat_form_field_1_Template, 4, 1, "mat-form-field", 127);
    i0.ɵɵelementStart(2, "mat-form-field", 128)(3, "input", 129);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_Template_input_click_3_listener() {
      i0.ɵɵrestoreView(_r95);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r93 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r93.addOption(f_r46));
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r46["options"])("ngForTrackBy", ctx_r62.trackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 3, "form.add_option"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_mat_form_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 128)(1, "input", 134);
    i0.ɵɵlistener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_mat_form_field_3_Template_input_ngModelChange_1_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r103);
      const cIdx_r100 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r101 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r101.optionChanged(f_r46.options["columns"], $event, cIdx_r100));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 135);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_mat_form_field_3_Template_button_click_2_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r103);
      const cIdx_r100 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r104 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r104.removeOptionColumn(f_r46.options["columns"], cIdx_r100));
    });
    i0.ɵɵelement(3, "mat-icon", 132);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const c_r99 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", c_r99);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 108)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const t_r114 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r114);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "form." + t_r114));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "input", 122);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_8_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r117);
      const e_r109 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(e_r109.options["decimals"], $event) || (e_r109.options["decimals"] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const e_r109 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", e_r109.options["decimals"]);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 2, "form.decimals"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_9_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r121);
      const e_r109 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(e_r109.options["suffix"], $event) || (e_r109.options["suffix"] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 131);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_9_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r121);
      const iIdx_r110 = i0.ɵɵnextContext().index;
      const r_r106 = i0.ɵɵnextContext().$implicit;
      const ctx_r122 = i0.ɵɵnextContext(7);
      return i0.ɵɵresetView(ctx_r122.removeItem(r_r106["items"], iIdx_r110));
    });
    i0.ɵɵelement(4, "mat-icon", 132);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const e_r109 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", e_r109.options["suffix"]);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 2, "form.suffix"));
  }
}
const _c0 = () => ["radio-button", "text", "number", "paragraph", "an_empty_field"];
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r127 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 140)(1, "mat-form-field", 141);
    i0.ɵɵelement(2, "mat-label", 142);
    i0.ɵɵelementStart(3, "mat-select", 143);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_Template_mat_select_ngModelChange_3_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r127);
      const e_r109 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(e_r109.type, $event) || (e_r109.type = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_Template_mat_select_ngModelChange_3_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r127);
      const e_r109 = restoredCtx.$implicit;
      const ctx_r128 = i0.ɵɵnextContext(8);
      return i0.ɵɵresetView(ctx_r128.fieldTypeChange(e_r109));
    });
    i0.ɵɵtemplate(4, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_option_4_Template, 4, 4, "mat-option", 100);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "mat-form-field", 6)(6, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_Template_input_ngModelChange_6_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r127);
      const e_r109 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(e_r109.label, $event) || (e_r109.label = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_8_Template, 3, 4, "mat-form-field", 112)(9, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_mat_form_field_9_Template, 5, 4, "mat-form-field", 112);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const e_r109 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", e_r109.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(8, _c0));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", e_r109.label);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(7, 6, "form.field_label"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", e_r109.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r109.type === "text");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 125)(1, "fieldset", 136)(2, "legend");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_div_4_Template, 10, 9, "div", 137);
    i0.ɵɵelementStart(5, "mat-form-field", 128)(6, "input", 129);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_Template_input_click_6_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r131);
      const r_r106 = restoredCtx.$implicit;
      const ctx_r130 = i0.ɵɵnextContext(7);
      return i0.ɵɵresetView(ctx_r130.addRowElement(r_r106));
    });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 138)(9, "button", 139);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_Template_button_click_9_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r131);
      const rIdx_r107 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r132 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r132.removeItem(f_r46.options["rows"], rIdx_r107));
    });
    i0.ɵɵelement(10, "mat-icon", 132);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const r_r106 = ctx.$implicit;
    const rIdx_r107 = ctx.index;
    const ctx_r98 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("L_", rIdx_r107 + 1, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", r_r106["items"])("ngForTrackBy", ctx_r98.trackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(7, 4, "form.add_item"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r136 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵelement(1, "hr", 30);
    i0.ɵɵelementStart(2, "div", 126);
    i0.ɵɵtemplate(3, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_mat_form_field_3_Template, 4, 1, "mat-form-field", 127);
    i0.ɵɵelementStart(4, "mat-form-field", 128)(5, "input", 129);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_Template_input_click_5_listener() {
      i0.ɵɵrestoreView(_r136);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r134 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r134.addOption(f_r46, "columns"));
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(7, "hr", 30);
    i0.ɵɵelementStart(8, "div", 126);
    i0.ɵɵtemplate(9, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_div_9_Template, 11, 6, "div", 133);
    i0.ɵɵelementStart(10, "mat-form-field", 128)(11, "input", 129);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_Template_input_click_11_listener() {
      i0.ɵɵrestoreView(_r136);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r137 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r137.addTableLayoutRow(f_r46));
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r63 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", f_r46.options["columns"])("ngForTrackBy", ctx_r63.trackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(6, 6, "form.add_header"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", f_r46.options["rows"])("ngForTrackBy", ctx_r63.trackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(12, 8, "form.add_row"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_mat_option_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 108)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const t_r144 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r144);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "form." + t_r144));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 151);
    i0.ɵɵelement(1, "span", 152)(2, "mat-icon", 153);
    i0.ɵɵelementEnd();
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_img_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 154);
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("src", f_r46.picture, i0.ɵɵsanitizeUrl);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_button_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r148 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 155);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_button_17_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r148);
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r146 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r146.resetPicture(f_r46, $event));
    });
    i0.ɵɵelement(1, "mat-icon", 132);
    i0.ɵɵelementEnd();
  }
}
const _c1 = () => ["unset", "auto"];
const _c2 = (a0, a1) => ({
  "empty-picture-field": a0,
  "picture-field": a1
});
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r151 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "hr", 30);
    i0.ɵɵelementStart(2, "div", 144)(3, "mat-form-field")(4, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r151);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.picture_style.height, $event) || (f_r46.config.picture_style.height = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "mat-form-field")(7, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r151);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.picture_style.width, $event) || (f_r46.config.picture_style.width = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "mat-form-field");
    i0.ɵɵelement(10, "mat-label", 145);
    i0.ɵɵelementStart(11, "mat-select", 99);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template_mat_select_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r151);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.picture_style["margin-left"], $event) || (f_r46.config.picture_style["margin-left"] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(12, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_mat_option_12_Template, 4, 4, "mat-option", 100);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 146);
    i0.ɵɵtwoWayListener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template_div_filesChange_13_listener($event) {
      i0.ɵɵrestoreView(_r151);
      const ctx_r156 = i0.ɵɵnextContext(6);
      i0.ɵɵtwoWayBindingSet(ctx_r156.files, $event) || (ctx_r156.files = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template_div_filesChange_13_listener($event) {
      i0.ɵɵrestoreView(_r151);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r157 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r157.editPictureField(f_r46, $event));
    });
    i0.ɵɵtemplate(14, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_div_14_Template, 3, 0, "div", 147);
    i0.ɵɵelementStart(15, "div", 148);
    i0.ɵɵtemplate(16, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_img_16_Template, 1, 1, "img", 149)(17, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_button_17_Template, 2, 0, "button", 150);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r64 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.picture_style.height);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(5, 12, "form.height"));
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.picture_style.width);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(8, 14, "form.width"));
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.picture_style["margin-left"]);
    i0.ɵɵproperty("compareWith", ctx_r64.compareCondition);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(16, _c1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c2, !f_r46.picture, !!f_r46.picture));
    i0.ɵɵtwoWayProperty("files", ctx_r64.files);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !f_r46.picture);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", f_r46.picture);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.picture);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r162 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 156)(1, "mat-form-field", 6)(2, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_23_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r162);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.options.formula, $event) || (f_r46.options.formula = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.options.formula);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 2, "form.base_formula"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 161);
    i0.ɵɵelement(1, "span", 42);
    i0.ɵɵelementEnd();
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_7_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r177 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-checkbox", 169);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_7_ng_container_5_Template_mat_checkbox_ngModelChange_1_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r177);
      const o_r173 = restoredCtx.$implicit;
      const vr_r166 = i0.ɵɵnextContext(2).$implicit;
      vr_r166 == null ? null : i0.ɵɵtwoWayBindingSet(vr_r166.value[o_r173], $event) || (vr_r166.value[o_r173] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const o_r173 = ctx.$implicit;
    const vr_r166 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", vr_r166 == null ? null : vr_r166.value[o_r173]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(o_r173);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 166)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 167);
    i0.ɵɵtemplate(5, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_7_ng_container_5_Template, 4, 2, "ng-container", 168);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r168 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "form.value"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", f_r46["options"])("ngForTrackBy", ctx_r168.trackByFn);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_8_mat_radio_button_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 108);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const o_r181 = ctx.$implicit;
    i0.ɵɵproperty("value", o_r181);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", o_r181, " ");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 170);
    i0.ɵɵelement(1, "input", 171);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "mat-radio-group", 172);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_8_Template_mat_radio_group_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r184);
      const vr_r166 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(vr_r166.value, $event) || (vr_r166.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(4, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_8_mat_radio_button_4_Template, 2, 2, "mat-radio-button", 100);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const vr_r166 = i0.ɵɵnextContext().$implicit;
    const f_r46 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", f_r46.label)("placeholder", i0.ɵɵpipeBind1(2, 5, "form.value"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", vr_r166.value);
    i0.ɵɵproperty("fxLayout", "row");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r46.options);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_mat_form_field_9_mat_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 108);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const o_r188 = ctx.$implicit;
    i0.ɵɵproperty("value", o_r188);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", o_r188, " ");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_mat_form_field_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r191 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-select", 143);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_mat_form_field_9_Template_mat_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r191);
      const vr_r166 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(vr_r166.value, $event) || (vr_r166.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(5, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_mat_form_field_9_mat_option_5_Template, 2, 2, "mat-option", 100);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const vr_r166 = i0.ɵɵnextContext().$implicit;
    const f_r46 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "form.value"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", vr_r166.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r46.options);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r197 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 156)(1, "mat-form-field", 173)(2, "input", 174);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_10_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r197);
      const f_r46 = i0.ɵɵnextContext(4).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.value, $event) || (f_r46.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-datepicker-toggle", 175);
    i0.ɵɵelement(5, "mat-icon", 176);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker", null, 177);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r194 = i0.ɵɵreference(7);
    const f_r46 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 4, "form.value"))("matDatepicker", _r194);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r194);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r200 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 162);
    i0.ɵɵelementStart(1, "div", 24)(2, "mat-form-field", 6)(3, "input", 163);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_Template_input_ngModelChange_3_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r200);
      const vr_r166 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(vr_r166.condition, $event) || (vr_r166.condition = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 131);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_Template_button_click_5_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r200);
      const vIdx_r167 = restoredCtx.index;
      const f_r46 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r201 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r201.removeOptionRow(f_r46 == null ? null : f_r46.config == null ? null : f_r46.config.value_rules, vIdx_r167));
    });
    i0.ɵɵelement(6, "mat-icon", 132);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_7_Template, 6, 5, "ng-template", 164)(8, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_8_Template, 5, 7, "ng-template", 164)(9, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_mat_form_field_9_Template, 6, 5, "mat-form-field", 165)(10, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_ng_template_10_Template, 8, 6, "ng-template", 164);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const vr_r166 = ctx.$implicit;
    const f_r46 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngSwitch", f_r46.type);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", vr_r166.condition);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 7, "form.condition"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngSwitchCase", "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "radio-button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "list");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "date");
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_Template(rf, ctx) {
  if (rf & 1) {
    const _r205 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-expansion-panel", 119);
    i0.ɵɵlistener("opened", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_Template_mat_expansion_panel_opened_0_listener() {
      i0.ɵɵrestoreView(_r205);
      const ctx_r204 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r204.valueRulesExpanded = true);
    })("closed", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_Template_mat_expansion_panel_closed_0_listener() {
      i0.ɵɵrestoreView(_r205);
      const ctx_r206 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r206.valueRulesExpanded = false);
    });
    i0.ɵɵelementStart(1, "mat-expansion-panel-header")(2, "mat-panel-title")(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_div_6_Template, 2, 0, "div", 157);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_ng_container_8_Template, 11, 9, "ng-container", 158);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelement(10, "span", 6);
    i0.ɵɵelementStart(11, "button", 159);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_Template_button_click_11_listener($event) {
      i0.ɵɵrestoreView(_r205);
      const f_r46 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r207 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r207.addValueRule(f_r46, $event));
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelement(13, "mat-icon", 160);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "form.value_rules"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(f_r46 == null ? null : f_r46.config == null ? null : f_r46.config.value_rules) || (f_r46 == null ? null : f_r46.config == null ? null : f_r46.config.value_rules.length) == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", f_r46 == null ? null : f_r46.config == null ? null : f_r46.config.value_rules);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(12, 6, "form.add"));
  }
}
const _c3 = () => ["date", "text", "long-text", "number"];
const _c4 = () => ["checkbox", "list", "radio-button"];
const _c5 = () => ["checkbox", "radio-button", "list", "date"];
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r212 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "br")(2, "hr", 30)(3, "br");
    i0.ɵɵelementStart(4, "mat-accordion", 109)(5, "mat-expansion-panel", 110)(6, "mat-expansion-panel-header")(7, "mat-panel-title")(8, "h4");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 97)(12, "div", 24)(13, "mat-form-field", 58)(14, "input", 111);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_input_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r212);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.label, $event) || (f_r46.label = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_16_Template, 3, 4, "mat-form-field", 112)(17, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_17_Template, 3, 4, "mat-form-field", 112)(18, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_form_field_18_Template, 4, 4, "mat-form-field", 112);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_19_Template, 4, 4, "div", 113)(20, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_20_Template, 5, 5, "div", 114)(21, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_21_Template, 13, 10, "div", 114)(22, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_22_Template, 18, 20, "div", 115)(23, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_div_23_Template, 4, 4, "div", 116);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "mat-expansion-panel")(25, "mat-expansion-panel-header")(26, "mat-panel-title")(27, "h4");
    i0.ɵɵtext(28, "Style");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(29, "div", 20)(30, "mat-form-field", 6)(31, "input", 117);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_input_ngModelChange_31_listener($event) {
      i0.ɵɵrestoreView(_r212);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.classes, $event) || (f_r46.config.classes = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "mat-form-field", 6)(33, "textarea", 118);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_textarea_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r212);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.cssStyle, $event) || (f_r46.config.cssStyle = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(34, "mat-expansion-panel", 119);
    i0.ɵɵlistener("opened", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_mat_expansion_panel_opened_34_listener() {
      i0.ɵɵrestoreView(_r212);
      const ctx_r217 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r217.displayRulesExpanded = true);
    })("closed", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_mat_expansion_panel_closed_34_listener() {
      i0.ɵɵrestoreView(_r212);
      const ctx_r218 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r218.displayRulesExpanded = false);
    });
    i0.ɵɵelementStart(35, "mat-expansion-panel-header")(36, "mat-panel-title")(37, "h4");
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(40, "mat-form-field", 6)(41, "textarea", 120);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template_textarea_ngModelChange_41_listener($event) {
      i0.ɵɵrestoreView(_r212);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.config.display_rule, $event) || (f_r46.config.display_rule = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(42, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_mat_expansion_panel_42_Template, 14, 8, "mat-expansion-panel", 121);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 18, "form.details"));
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.label);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 20, "form.field_label"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", f_r46.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.options.is_measurement && i0.ɵɵpureFunction0(24, _c3).includes(f_r46.type));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(25, _c4).includes(f_r46.type));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "table-layout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "image" || f_r46.picture);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "formula");
    i0.ɵɵadvance(8);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.classes);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.cssStyle);
    i0.ɵɵproperty("rows", 5);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(39, 22, "form.display_rule"));
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.config.display_rule);
    i0.ɵɵproperty("rows", 5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(26, _c5).includes(f_r46.type));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r224 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-slide-toggle", 178);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_19_Template_mat_slide_toggle_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r224);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.required, $event) || (f_r46.required = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelement(1, "span", 179);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtwoWayProperty("ngModel", f_r46.required);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r228 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-slide-toggle", 178);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_20_Template_mat_slide_toggle_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r228);
      const f_r46 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.options.has_border, $event) || (f_r46.options.has_border = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelement(1, "span", 180);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r46 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtwoWayProperty("ngModel", f_r46.options.has_border);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r231 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 181);
    i0.ɵɵtwoWayListener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_24_Template_button_filesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r231);
      const ctx_r230 = i0.ɵɵnextContext(5);
      i0.ɵɵtwoWayBindingSet(ctx_r230.files, $event) || (ctx_r230.files = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_24_Template_button_filesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r231);
      const ctx_r234 = i0.ɵɵnextContext();
      const f_r46 = ctx_r234.$implicit;
      const fieldIdx_r47 = ctx_r234.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r232 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r232.addFieldImage(b_r28, f_r46, fieldIdx_r47, $event));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 182);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(5);
    i0.ɵɵtwoWayProperty("files", ctx_r53.files);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 2, "form.add_image"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r236 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_25_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r236);
      const fieldIdx_r47 = i0.ɵɵnextContext().index;
      const blockIdx_r29 = i0.ɵɵnextContext(2).index;
      const ctx_r235 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView((ctx_r235.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47] = true));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 86);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.expand"));
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r240 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_26_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r240);
      const fieldIdx_r47 = i0.ɵɵnextContext().index;
      const blockIdx_r29 = i0.ɵɵnextContext(2).index;
      const ctx_r239 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView((ctx_r239.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47] = false));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 87);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.collapse"));
  }
}
const _c6 = () => ["table-layout", "image"];
function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r244 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card", 93)(1, "div", 94)(2, "button", 95);
    i0.ɵɵelement(3, "mat-icon", 96);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-card-content", 97)(5, "div", 24)(6, "mat-form-field", 6)(7, "input", 98);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_input_ngModelChange_7_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const f_r46 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.name, $event) || (f_r46.name = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_input_change_7_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const f_r46 = restoredCtx.$implicit;
      const fieldIdx_r47 = restoredCtx.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r245 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r245.checkNameUniqueness(f_r46.name, "field_name_" + fieldIdx_r47, b_r28.fields));
    });
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_hint_9_Template, 3, 3, "mat-hint", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "mat-form-field", 6)(11, "mat-label");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "mat-select", 99);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_mat_select_ngModelChange_14_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const f_r46 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(f_r46.type, $event) || (f_r46.type = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_mat_select_ngModelChange_14_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const f_r46 = restoredCtx.$implicit;
      const fieldIdx_r47 = restoredCtx.index;
      const blockIdx_r29 = i0.ɵɵnextContext(2).index;
      const ctx_r248 = i0.ɵɵnextContext(2);
      ctx_r248.fieldTypeChange(f_r46);
      return i0.ɵɵresetView((ctx_r248.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47] = true));
    });
    i0.ɵɵtemplate(15, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_option_15_Template, 3, 4, "mat-option", 100);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(16, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_div_16_Template, 43, 27, "div", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "mat-card-actions", 61);
    i0.ɵɵelement(18, "span", 6);
    i0.ɵɵtemplate(19, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_19_Template, 2, 1, "mat-slide-toggle", 102)(20, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_mat_slide_toggle_20_Template, 2, 1, "mat-slide-toggle", 102);
    i0.ɵɵelementStart(21, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_click_21_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const f_r46 = restoredCtx.$implicit;
      const fieldIdx_r47 = restoredCtx.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r250 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r250.duplicateField(b_r28, f_r46, fieldIdx_r47));
    });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelement(23, "mat-icon", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_24_Template, 3, 4, "button", 103)(25, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_25_Template, 3, 3, "button", 68)(26, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_button_26_Template, 3, 3, "button", 68);
    i0.ɵɵelementStart(27, "button", 70);
    i0.ɵɵelement(28, "mat-icon", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-menu", 72, 104)(31, "button", 74);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_click_31_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const fieldIdx_r47 = restoredCtx.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r252 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r252.newField(b_r28, fieldIdx_r47));
    });
    i0.ɵɵelement(32, "mat-icon", 105)(33, "span", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "button", 74);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_click_34_listener() {
      i0.ɵɵrestoreView(_r244);
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r254 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r254.newBlock(b_r28));
    });
    i0.ɵɵelement(35, "mat-icon", 81)(36, "span", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "button", 106);
    i0.ɵɵtwoWayListener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_filesChange_37_listener($event) {
      i0.ɵɵrestoreView(_r244);
      const ctx_r256 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r256.files, $event) || (ctx_r256.files = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("filesChange", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_filesChange_37_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const fieldIdx_r47 = restoredCtx.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r257 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r257.addPictureField(b_r28, $event, fieldIdx_r47));
    });
    i0.ɵɵelement(38, "mat-icon", 107)(39, "span", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "button", 74);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template_button_click_40_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r244);
      const fieldIdx_r47 = restoredCtx.index;
      const b_r28 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r259 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r259.removeItem(b_r28["fields"], fieldIdx_r47));
    });
    i0.ɵɵelement(41, "mat-icon", 89)(42, "span", 90);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const f_r46 = ctx.$implicit;
    const fieldIdx_r47 = ctx.index;
    const _r56 = i0.ɵɵreference(30);
    const ctx_r261 = i0.ɵɵnextContext(2);
    const b_r28 = ctx_r261.$implicit;
    const blockIdx_r29 = ctx_r261.index;
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵclassProp("mat-form-field-invalid", ctx_r45.checkNameUniqueness(f_r46.name, "field_name_" + fieldIdx_r47, b_r28.fields));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", "field_name_" + fieldIdx_r47);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(8, 19, "form.identifier"));
    i0.ɵɵtwoWayProperty("ngModel", f_r46.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r45.checkNameUniqueness(f_r46.name, "field_name_" + fieldIdx_r47, b_r28.fields));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 21, "form.type"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", f_r46.type);
    i0.ɵɵproperty("compareWith", ctx_r45.compareCondition);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r45.fieldTypes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r45.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", f_r46.type !== "table-layout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r46.type === "table-layout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(22, 23, "form.duplicate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !f_r46.picture && !i0.ɵɵpureFunction0(25, _c6).includes(f_r46.type));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r45.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r45.displayedFields["block_" + blockIdx_r29 + "_field_" + fieldIdx_r47]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", _r56);
    i0.ɵɵadvance(10);
    i0.ɵɵtwoWayProperty("files", ctx_r45.files);
  }
}
function FormSetupComponent_ng_template_54_div_1_div_44_Template(rf, ctx) {
  if (rf & 1) {
    const _r264 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵlistener("cdkDropListDropped", function FormSetupComponent_ng_template_54_div_1_div_44_Template_div_cdkDropListDropped_0_listener($event) {
      i0.ɵɵrestoreView(_r264);
      const b_r28 = i0.ɵɵnextContext().$implicit;
      const ctx_r262 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r262.drop(b_r28, $event));
    });
    i0.ɵɵtemplate(1, FormSetupComponent_ng_template_54_div_1_div_44_mat_card_1_Template, 43, 26, "mat-card", 92);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const b_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", b_r28["fields"])("ngForTrackBy", ctx_r35.trackByFn);
  }
}
function FormSetupComponent_ng_template_54_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r267 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54)(1, "mat-card", 55)(2, "mat-card-content", 20)(3, "div", 24)(4, "mat-form-field", 6)(5, "input", 56);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_Template_input_ngModelChange_5_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(b_r28.name, $event) || (b_r28.name = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FormSetupComponent_ng_template_54_div_1_mat_hint_7_Template, 3, 3, "mat-hint", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-form-field", 58)(9, "input", 59);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_Template_input_ngModelChange_9_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(b_r28.label, $event) || (b_r28.label = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "mat-form-field", 6)(12, "input", 60);
    i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_ng_template_54_div_1_Template_input_ngModelChange_12_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(b_r28.config.display_rule, $event) || (b_r28.config.display_rule = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "mat-card-actions", 61)(15, "button", 62);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_15_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      b_r28.config.classes["layout-column"] = !b_r28.config.classes["layout-column"];
      b_r28.config.classes["layout-row"] = false;
      return i0.ɵɵresetView((b_r28.config.classes["layout-wrap"] = false));
    });
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelement(17, "mat-icon", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 64);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_18_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      b_r28.config.classes["layout-row"] = !b_r28.config.classes["layout-row"];
      return i0.ɵɵresetView((b_r28.config.classes["layout-column"] = false));
    });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelement(20, "mat-icon", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 66);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_21_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      return i0.ɵɵresetView((b_r28.config.classes["layout-wrap"] = !b_r28.config.classes["layout-wrap"]));
    });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelement(23, "mat-icon", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "span", 6);
    i0.ɵɵtemplate(25, FormSetupComponent_ng_template_54_div_1_button_25_Template, 3, 3, "button", 68)(26, FormSetupComponent_ng_template_54_div_1_button_26_Template, 3, 3, "button", 68);
    i0.ɵɵelementStart(27, "button", 69);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_27_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      const blockIdx_r29 = restoredCtx.index;
      const ctx_r273 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r273.duplicateBlock(b_r28, blockIdx_r29));
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelement(29, "mat-icon", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "button", 70);
    i0.ɵɵelement(31, "mat-icon", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "mat-menu", 72, 73)(34, "button", 74);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_34_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      const ctx_r274 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r274.newField(b_r28));
    });
    i0.ɵɵelement(35, "mat-icon", 75)(36, "span", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "button", 77);
    i0.ɵɵtwoWayListener("filesChange", function FormSetupComponent_ng_template_54_div_1_Template_button_filesChange_37_listener($event) {
      i0.ɵɵrestoreView(_r267);
      const ctx_r275 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r275.files, $event) || (ctx_r275.files = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("filesChange", function FormSetupComponent_ng_template_54_div_1_Template_button_filesChange_37_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      const ctx_r276 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r276.addPictureField(b_r28, $event));
    });
    i0.ɵɵelement(38, "mat-icon", 78)(39, "span", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "button", 80);
    i0.ɵɵlistener("click", function FormSetupComponent_ng_template_54_div_1_Template_button_click_40_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r267);
      const b_r28 = restoredCtx.$implicit;
      const ctx_r277 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r277.newBlock(b_r28));
    });
    i0.ɵɵelement(41, "mat-icon", 81)(42, "span", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(43, FormSetupComponent_ng_template_54_div_1_button_43_Template, 3, 0, "button", 83);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(44, FormSetupComponent_ng_template_54_div_1_div_44_Template, 2, 2, "div", 84);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const b_r28 = ctx.$implicit;
    const blockIdx_r29 = ctx.index;
    const _r33 = i0.ɵɵreference(33);
    const blocks_r26 = i0.ɵɵnextContext().blocks;
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("mat-form-field-invalid", ctx_r27.checkNameUniqueness(b_r28.name, "block_name_" + blockIdx_r29, blocks_r26));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", "block_name_" + blockIdx_r29);
    i0.ɵɵtwoWayProperty("ngModel", b_r28.name);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(6, 24, "form.identifier"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r27.checkNameUniqueness(b_r28.name, "block_name_" + blockIdx_r29, blocks_r26));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", b_r28.label);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(10, 26, "form.block_label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", b_r28.config.display_rule);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(13, 28, "form.display_rule"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("color", b_r28.config.classes["layout-column"] ? "primary" : null);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(16, 30, "form.form_section_layout_column"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("color", b_r28.config.classes["layout-row"] ? "primary" : null);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(19, 32, "form.form_section_layout_row"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("color", b_r28.config.classes["layout-wrap"] ? "primary" : "accent");
    i0.ɵɵproperty("disabled", !b_r28.config.classes["layout-row"])("matTooltip", i0.ɵɵpipeBind1(22, 34, "form.form_section_layout_wrap"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r27.hiddenBlocks["block_" + blockIdx_r29] && b_r28.fields && b_r28.fields.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r27.hiddenBlocks["block_" + blockIdx_r29] && b_r28.fields && b_r28.fields.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(28, 36, "form.duplicate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matMenuTriggerFor", _r33);
    i0.ɵɵadvance(7);
    i0.ɵɵtwoWayProperty("files", ctx_r27.files);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r27.model.blocks.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r27.hiddenBlocks["block_" + blockIdx_r29]);
  }
}
function FormSetupComponent_ng_template_54_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtemplate(1, FormSetupComponent_ng_template_54_div_1_Template, 45, 38, "div", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const blocks_r26 = ctx.blocks;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", blocks_r26)("ngForTrackBy", ctx_r11.trackByFn);
  }
}
const _c7 = () => ({
  field: "name"
});
const _c8 = a0 => ({
  model: a0
});
const _c9 = a0 => ({
  blocks: a0
});
const _c10 = ["*"];
function FormBlockComponent_div_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function FormBlockComponent_div_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.calculateBlocFormula());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "mat-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "form.recalculate_block_fields"));
  }
}
function FormBlockComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 7);
    i0.ɵɵtemplate(4, FormBlockComponent_div_1_button_4_Template, 3, 3, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.model.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.hasFormulas());
  }
}
function FormBlockComponent_ng_container_5_ng_template_2_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-checkbox", 21);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_2_div_0_ng_container_4_Template_mat_checkbox_ngModelChange_1_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r27);
      const o_r23 = restoredCtx.$implicit;
      const f_r6 = i0.ɵɵnextContext(3).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value[o_r23], $event) || (f_r6.value[o_r23] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_2_div_0_ng_container_4_Template_mat_checkbox_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r28 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r28.emitBlockChange());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const o_r23 = ctx.$implicit;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", ctx_r22.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value[o_r23]);
    i0.ɵɵproperty("required", f_r6.required);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(o_r23);
  }
}
function FormBlockComponent_ng_container_5_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵtemplate(4, FormBlockComponent_ng_container_5_ng_template_2_div_0_ng_container_4_Template, 4, 4, "ng-container", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(f_r6["label"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", f_r6["options"])("ngForTrackBy", ctx_r21.trackByFn);
  }
}
function FormBlockComponent_ng_container_5_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_2_div_0_Template, 5, 3, "div", 17);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r7.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_mat_radio_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-radio-button", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const o_r34 = ctx.$implicit;
    i0.ɵɵproperty("value", o_r34);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", o_r34, " ");
  }
}
function FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 23);
    i0.ɵɵelement(1, "input", 24);
    i0.ɵɵelementStart(2, "mat-radio-group", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_Template_mat_radio_group_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r37);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_Template_mat_radio_group_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r37);
      const ctx_r38 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r38.emitBlockChange());
    });
    i0.ɵɵtemplate(3, FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_mat_radio_button_3_Template, 2, 2, "mat-radio-button", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", f_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", ctx_r32.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("fxLayout", "row");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r6.options);
  }
}
function FormBlockComponent_ng_container_5_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_3_mat_form_field_0_Template, 4, 5, "mat-form-field", 22);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "mat-form-field", 7)(2, "input", 30);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_4_div_0_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_4_div_0_Template_input_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r44);
      const ctx_r45 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r45.emitBlockChange());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r41 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("name", ctx_r41.model.name + f_r6.name);
    i0.ɵɵproperty("placeholder", f_r6.label);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required);
  }
}
function FormBlockComponent_ng_container_5_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_4_div_0_Template, 3, 4, "div", 28);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r9.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "mat-form-field", 7)(2, "textarea", 32);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_5_div_0_Template_textarea_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_5_div_0_Template_textarea_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r51);
      const ctx_r52 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r52.emitBlockChange());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r48 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("name", ctx_r48.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required)("placeholder", f_r6.label)("rows", f_r6.rows || 5);
  }
}
function FormBlockComponent_ng_container_5_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_5_div_0_Template, 3, 5, "div", 14);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "mat-form-field", 7)(2, "input", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_div_6_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const f_r6 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_div_6_Template_input_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r57);
      const ctx_r58 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r58.emitBlockChange());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("name", ctx_r11.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required)("placeholder", f_r6.label);
  }
}
function FormBlockComponent_ng_container_5_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "mat-form-field", 7)(2, "input", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_div_7_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r62);
      const f_r6 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_div_7_Template_input_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r62);
      const ctx_r63 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r63.emitBlockChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("name", ctx_r12.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required)("placeholder", f_r6.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, f_r6.options["suffix"]));
  }
}
function FormBlockComponent_ng_container_5_div_8_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 7)(1, "input", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_div_8_mat_form_field_1_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r68);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_div_8_mat_form_field_1_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r68);
      const ctx_r69 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r69.emitBlockChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 36);
    i0.ɵɵlistener("click", function FormBlockComponent_ng_container_5_div_8_mat_form_field_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r68);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r70 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r70.calculateFormula(f_r6));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "mat-icon", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r65 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", ctx_r65.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required)("placeholder", f_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(3, 5, "form.calculate"));
  }
}
function FormBlockComponent_ng_container_5_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, FormBlockComponent_ng_container_5_div_8_mat_form_field_1_Template, 5, 7, "mat-form-field", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r13.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_9_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "mat-form-field", 38)(2, "input", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_9_div_0_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r78);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_9_div_0_Template_input_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r78);
      const ctx_r79 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r79.emitBlockChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-datepicker-toggle", 40);
    i0.ɵɵelement(4, "mat-icon", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker", null, 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r75 = i0.ɵɵreference(6);
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r74 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("name", ctx_r74.model.name + f_r6.name);
    i0.ɵɵproperty("matDatepicker", _r75)("placeholder", f_r6.label);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", _r75);
  }
}
function FormBlockComponent_ng_container_5_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_9_div_0_Template, 7, 6, "div", 14);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r14.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const o_r84 = ctx.$implicit;
    i0.ɵɵproperty("value", o_r84);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", o_r84, " ");
  }
}
function FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r87 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 43);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_Template_mat_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r87);
      const f_r6 = i0.ɵɵnextContext(2).$implicit;
      i0.ɵɵtwoWayBindingSet(f_r6.value, $event) || (f_r6.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_Template_mat_select_ngModelChange_3_listener() {
      i0.ɵɵrestoreView(_r87);
      const ctx_r88 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r88.emitBlockChange());
    });
    i0.ɵɵtemplate(4, FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_mat_option_4_Template, 2, 2, "mat-option", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r82 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(f_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", ctx_r82.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", f_r6.value);
    i0.ɵɵproperty("required", f_r6.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r6.options);
  }
}
function FormBlockComponent_ng_container_5_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_10_mat_form_field_0_Template, 5, 5, "mat-form-field", 16);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r15.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_11_h5_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(f_r6.label);
  }
}
function FormBlockComponent_ng_container_5_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_11_h5_0_Template, 2, 1, "h5", 16);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r16.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 53);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r98 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(column_r98);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r111 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 56);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_1_Template_mat_checkbox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r111);
      const element_r103 = i0.ɵɵnextContext().$implicit;
      const column_r98 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(element_r103[column_r98], $event) || (element_r103[column_r98] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_1_Template_mat_checkbox_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r111);
      const ctx_r113 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r113.emitBlockChange());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r103 = i0.ɵɵnextContext().$implicit;
    const column_r98 = i0.ɵɵnextContext().$implicit;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r105 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("name", ctx_r105.model.name + f_r6.name);
    i0.ɵɵtwoWayProperty("ngModel", element_r103[column_r98]);
    i0.ɵɵproperty("disableRipple", true);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eIdx_r104 = i0.ɵɵnextContext().index;
    const cIdx_r99 = i0.ɵɵnextContext().index;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r106 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r106.getElementLabel(f_r6, cIdx_r99, eIdx_r104), " ");
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "input", 57);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_3_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r122);
      const element_r103 = i0.ɵɵnextContext().$implicit;
      const column_r98 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(element_r103[column_r98], $event) || (element_r103[column_r98] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_3_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r122);
      const ctx_r124 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r124.emitBlockChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext();
    const eIdx_r104 = ctx_r127.index;
    const element_r103 = ctx_r127.$implicit;
    const ctx_r126 = i0.ɵɵnextContext();
    const cIdx_r99 = ctx_r126.index;
    const column_r98 = ctx_r126.$implicit;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r107 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("name", ctx_r107.model.name + f_r6.name);
    i0.ɵɵproperty("placeholder", ctx_r107.getElementLabel(f_r6, cIdx_r99, eIdx_r104));
    i0.ɵɵtwoWayProperty("ngModel", element_r103[column_r98]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r107.getElementSuffix(f_r6, cIdx_r99, eIdx_r104));
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r130 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 58);
    i0.ɵɵtwoWayListener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_4_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r130);
      const element_r103 = i0.ɵɵnextContext().$implicit;
      const column_r98 = i0.ɵɵnextContext().$implicit;
      i0.ɵɵtwoWayBindingSet(element_r103[column_r98], $event) || (element_r103[column_r98] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_4_Template_input_ngModelChange_0_listener() {
      i0.ɵɵrestoreView(_r130);
      const ctx_r132 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r132.emitBlockChange());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r135 = i0.ɵɵnextContext();
    const eIdx_r104 = ctx_r135.index;
    const element_r103 = ctx_r135.$implicit;
    const ctx_r134 = i0.ɵɵnextContext();
    const cIdx_r99 = ctx_r134.index;
    const column_r98 = ctx_r134.$implicit;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r108 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("name", ctx_r108.model.name + f_r6.name);
    i0.ɵɵproperty("placeholder", ctx_r108.getElementLabel(f_r6, cIdx_r99, eIdx_r104));
    i0.ɵɵtwoWayProperty("ngModel", element_r103[column_r98]);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 54);
    i0.ɵɵtemplate(1, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_1_Template, 1, 3, "ng-template", 13)(2, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_p_2_Template, 2, 1, "p", 55)(3, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_3_Template, 4, 4, "ng-template", 13)(4, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_ng_template_4_Template, 1, 3, "ng-template", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eIdx_r104 = ctx.index;
    const cIdx_r99 = i0.ɵɵnextContext().index;
    const f_r6 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r101 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r101.getElementType(f_r6, cIdx_r99, eIdx_r104));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "radio-button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "paragraph");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "number");
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 50);
    i0.ɵɵtemplate(1, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_th_1_Template, 2, 1, "th", 51)(2, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_td_2_Template, 5, 5, "td", 52);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r98 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r98);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_tr_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 59);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 60);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "table", 46);
    i0.ɵɵtemplate(2, FormBlockComponent_ng_container_5_ng_template_12_div_0_ng_container_2_Template, 3, 1, "ng-container", 47)(3, FormBlockComponent_ng_container_5_ng_template_12_div_0_tr_3_Template, 1, 0, "tr", 48)(4, FormBlockComponent_ng_container_5_ng_template_12_div_0_tr_4_Template, 1, 0, "tr", 49);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("dataSource", f_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", f_r6.options["columns"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matHeaderRowDef", f_r6.options["columns"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matRowDefColumns", f_r6.options["columns"]);
  }
}
function FormBlockComponent_ng_container_5_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_12_div_0_Template, 5, 4, "div", 44);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r17.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_13_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(f_r6["label"]);
  }
}
function FormBlockComponent_ng_container_5_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_13_div_0_Template, 3, 1, "div", 35);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r18.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_ng_template_14_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵelement(1, "img", 63);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", f_r6 == null ? null : f_r6.config == null ? null : f_r6.config.picture_style)("src", f_r6.picture, i0.ɵɵsanitizeUrl);
  }
}
function FormBlockComponent_ng_container_5_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FormBlockComponent_ng_container_5_ng_template_14_div_0_Template, 2, 2, "div", 61);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r19.handleDisplayRules(f_r6));
  }
}
function FormBlockComponent_ng_container_5_div_15_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 65);
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngStyle", f_r6.config["picture_style"])("src", f_r6.picture, i0.ɵɵsanitizeUrl);
  }
}
function FormBlockComponent_ng_container_5_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormBlockComponent_ng_container_5_div_15_img_1_Template, 1, 2, "img", 64);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const f_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r6.type !== "image" && f_r6.picture);
  }
}
function FormBlockComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, FormBlockComponent_ng_container_5_ng_template_2_Template, 1, 1, "ng-template", 13)(3, FormBlockComponent_ng_container_5_ng_template_3_Template, 1, 1, "ng-template", 13)(4, FormBlockComponent_ng_container_5_ng_template_4_Template, 1, 1, "ng-template", 13)(5, FormBlockComponent_ng_container_5_ng_template_5_Template, 1, 1, "ng-template", 13)(6, FormBlockComponent_ng_container_5_div_6_Template, 3, 4, "div", 14)(7, FormBlockComponent_ng_container_5_div_7_Template, 6, 7, "div", 14)(8, FormBlockComponent_ng_container_5_div_8_Template, 2, 1, "div", 15)(9, FormBlockComponent_ng_container_5_ng_template_9_Template, 1, 1, "ng-template", 13)(10, FormBlockComponent_ng_container_5_ng_template_10_Template, 1, 1, "ng-template", 13)(11, FormBlockComponent_ng_container_5_ng_template_11_Template, 1, 1, "ng-template", 13)(12, FormBlockComponent_ng_container_5_ng_template_12_Template, 1, 1, "ng-template", 13)(13, FormBlockComponent_ng_container_5_ng_template_13_Template, 1, 1, "ng-template", 13)(14, FormBlockComponent_ng_container_5_ng_template_14_Template, 1, 1, "ng-template", 13)(15, FormBlockComponent_ng_container_5_div_15_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const f_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", f_r6.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", f_r6 == null ? null : f_r6.config == null ? null : f_r6.config.classes)("ngStyle", ctx_r2.handleFieldStyle(f_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "radio-button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "long-text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r6.type === "number" && !f_r6.options["suffix"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", f_r6.type === "number" && f_r6.options["suffix"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "formula");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "date");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "list");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "title");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "table-layout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "paragraph");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "image");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.handleDisplayRules(f_r6));
  }
}
function FormComponent_ng_container_4_div_1_ft_form_block_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ft-form-block", 7);
    i0.ɵɵlistener("blockChange", function FormComponent_ng_container_4_div_1_ft_form_block_1_Template_ft_form_block_blockChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const b_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r6 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r6.handleChange(b_r3, $event));
    })("blockValid", function FormComponent_ng_container_4_div_1_ft_form_block_1_Template_ft_form_block_blockValid_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const b_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r9 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r9.handleBlockValid(b_r3.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const b_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("block", b_r3)("template", ctx_r5.model);
  }
}
function FormComponent_ng_container_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormComponent_ng_container_4_div_1_ft_form_block_1_Template, 1, 2, "ft-form-block", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const b_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showBlock(b_r3));
  }
}
function FormComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_ng_container_4_div_1_Template, 2, 1, "div", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.model.blocks)("ngForTrackBy", ctx_r1.trackByFn);
  }
}
class ProgressDialogComponent {
  constructor(_dialogRef, data) {
    this._dialogRef = _dialogRef;
    this.progress = null;
    this._observable = data.observable;
  }
  ngOnInit() {
    this._observable.subscribe({
      next: event => this.progress = Math.round(100 * event.loaded / event.total),
      complete: () => this._dialogRef.close()
    });
  }
}
ProgressDialogComponent.ɵfac = function ProgressDialogComponent_Factory(t) {
  return new (t || ProgressDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
};
ProgressDialogComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: ProgressDialogComponent,
  selectors: [["ft-progress-bar"]],
  decls: 2,
  vars: 2,
  consts: [["mat-dialog-content", "", "fxLayout", "column"], [3, "mode", "value"]],
  template: function ProgressDialogComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵelement(1, "mat-progress-bar", 1);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("mode", ctx.progress ? "determinate" : "buffer")("value", ctx.progress);
    }
  },
  dependencies: [i2.MatProgressBar, i1.MatDialogContent, i24.DefaultLayoutDirective],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressDialogComponent, [{
    type: Component,
    args: [{
      selector: 'ft-progress-bar',
      template: `
        <div mat-dialog-content fxLayout="column">
            <mat-progress-bar
                [mode]="progress ? 'determinate' : 'buffer'"
                [value]="progress"
            ></mat-progress-bar>
        </div>
    `
    }]
  }], function () {
    return [{
      type: i1.MatDialogRef
    }, {
      type: undefined,
      decorators: [{
        type: Inject,
        args: [MAT_DIALOG_DATA]
      }]
    }];
  }, null);
})();
class FormSetupService {
  constructor(_http, _dialog) {
    this._http = _http;
    this._dialog = _dialog;
    this._templates$ = new BehaviorSubject([]);
  }
  set formsTemplates(value) {
    this._templates$.next(value);
  }
  get formsTemplates() {
    return this._templates$.getValue();
  }
  loadFormsTemplates() {
    return this._http.get('/api/form-template/').pipe(map(data => this.formsTemplates = data));
  }
  getFormsTemplates() {
    // TODO
    // return this._http.get<any>(`/api/form-template/`);
    return of([]);
  }
  getFormTemplate(pk) {
    return this._http.get(`/api/form-template/${pk}/`);
  }
  saveFormTemplate(data) {
    return this._http.post(`/api/form-template/${!isNil(data.id) ? data.id + '/' : ''}`, data);
  }
  deleteFormTemplate(pk) {
    return this._http.delete(`/api/form-template/${pk}/`);
  }
  exportFormTemplate(pk, fileName) {
    return this.download(`/api/form-template/${pk}/export/`, fileName);
  }
  downloadNative(url) {
    const subject = new Subject();
    const request = new HttpRequest('GET', url, null, {
      responseType: 'blob',
      reportProgress: true
    });
    this.openProgressDialog(subject);
    return this._http.request(request).pipe(tap(event => event.type === HttpEventType.DownloadProgress ? subject.next(event) : noop()), filter(event => event.type === HttpEventType.Response), tap(() => subject.complete()), catchError(err => {
      subject.complete();
      return throwError(err);
    }));
  }
  download(url, name) {
    return this.downloadNative(url).pipe(map(response => () => saveAs(response.body, name)));
  }
  openProgressDialog(request) {
    this._dialog.open(ProgressDialogComponent, {
      data: {
        observable: request
      },
      width: '40%',
      minWidth: '500px',
      disableClose: true,
      panelClass: 'ft-download-progress-dialog'
    });
  }
}
FormSetupService.ɵfac = function FormSetupService_Factory(t) {
  return new (t || FormSetupService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i1.MatDialog));
};
FormSetupService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: FormSetupService,
  factory: FormSetupService.ɵfac,
  providedIn: 'root'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSetupService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], function () {
    return [{
      type: i1$1.HttpClient
    }, {
      type: i1.MatDialog
    }];
  }, null);
})();
const FT_CUSTOM_ASYNC_VALIDATOR = {
  multi: true,
  provide: NG_ASYNC_VALIDATORS,
  useExisting: forwardRef(() => FieldValidationDirective)
};
class FieldValidationDirective {
  constructor(_http) {
    this._http = _http;
    this._validatorChange = () => {};
    this.query = {};
    this.noWatch = false;
  }
  ngOnChanges(changes) {
    if (!this._validatorChange) return;else if ('validator' in changes && !this.noWatch || 'watchedValue' in changes) setTimeout(() => this._validatorChange());
  }
  validate(control) {
    const value = control.value;
    if (isEmpty(value) && !isNumber(value)) return of(null);else if (isString(this.validator)) {
      // query params 'api/form-template?name=nn'
      return this._http.get(`${this.validator}?${this.query.field}=${value}`).pipe(map(res => res ? null : {
        exists: {
          valid: false
        }
      }));
    } else if (isObservable(this.validator)) return this.validator;else return of(this.validator);
  }
  registerOnValidatorChange(fn) {
    this._validatorChange = fn;
  }
}
FieldValidationDirective.ɵfac = function FieldValidationDirective_Factory(t) {
  return new (t || FieldValidationDirective)(i0.ɵɵdirectiveInject(i1$1.HttpClient));
};
FieldValidationDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
  type: FieldValidationDirective,
  selectors: [["", "ftFieldValidation", ""]],
  inputs: {
    query: "query",
    watchedValue: "watchedValue",
    noWatch: "noWatch",
    validator: [i0.ɵɵInputFlags.None, "ftFieldValidation", "validator"]
  },
  features: [i0.ɵɵProvidersFeature([FT_CUSTOM_ASYNC_VALIDATOR]), i0.ɵɵNgOnChangesFeature]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldValidationDirective, [{
    type: Directive,
    args: [{
      selector: '[ftFieldValidation]',
      providers: [FT_CUSTOM_ASYNC_VALIDATOR]
    }]
  }], function () {
    return [{
      type: i1$1.HttpClient
    }];
  }, {
    query: [{
      type: Input,
      args: ['query']
    }],
    watchedValue: [{
      type: Input,
      args: ['watchedValue']
    }],
    noWatch: [{
      type: Input,
      args: ['noWatch']
    }],
    validator: [{
      type: Input,
      args: ['ftFieldValidation']
    }]
  });
})();
class FormSetupComponent {
  constructor(translateService, formSetupService, _route, _router, snackBar) {
    this.translateService = translateService;
    this.formSetupService = formSetupService;
    this._route = _route;
    this._router = _router;
    this.snackBar = snackBar;
    this.separatorKeysCodes = [ENTER, COMMA];
    this.valueRulesExpanded = false;
    this.displayRulesExpanded = false;
    this.model = {};
    this.items = [];
    this.fieldTypes = ['checkbox', 'radio-button', 'text', 'long-text', 'number', 'date', 'title', 'paragraph', 'list', 'image', 'table-layout', 'formula'];
    this.editedFieldName = null;
    this.defaultField = {
      type: 'checkbox',
      name: `${this.translateService.instant('form.field_name')}_1`,
      label: '',
      options: ['option1'],
      required: false,
      config: {
        value_rules: [],
        display_rule: [],
        cssStyle: null,
        classes: null
      },
      value: {}
    };
    this.defaultBlock = {
      name: `${this.translateService.instant('form.block_name')}_1`,
      label: null,
      fields: [],
      config: {
        classes: {},
        display_rule: null,
        cssStyle: null
      }
    };
    this.hiddenBlocks = {};
    this.files = [];
    this.measurements = [];
    this.currentTemplate = null;
    this.displayedFields = {};
    // this.busy = this.formSetupService.getFormsTemplates().subscribe(data => {
    this.items = this.formSetupService.formsTemplates;
    // });
  }
  //@ts-ignore
  set headerCustomTemplate(template) {
    this.customTemplateContent = template;
  }
  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      if (get(params, 'id')) {
        this.currentTemplate = get(params, 'id');
        this.formSetupService.getFormTemplate(this.currentTemplate).subscribe(data => {
          this.model = data;
        });
      } else if (get(params, 'copy')) {
        let copyObject = find(this.items, {
          id: parseInt(get(params, 'copy'))
        });
        this.model = assignIn(omit(copyObject, 'id'), {
          name: 'DUP_' + get(copyObject, 'name'),
          label: 'DUP_' + get(copyObject, 'label')
        });
      } else this.model = cloneDeep({
        blocks: [assignIn(this.defaultBlock, {
          fields: [cloneDeep(this.defaultField)]
        })]
      });
    });
  }
  initItems() {}
  handleImport(files) {
    let reader = new FileReader();
    reader.onloadend = this.fileReader.bind(this);
    reader.readAsText(files[0]);
  }
  fileReader(evt) {
    if (evt.target.readyState === FileReader.DONE) {
      this.currentTemplate = null;
      this.model = cloneDeep(omit(JSON.parse(evt.target.result), 'id'));
    }
  }
  handleNew() {
    this._navigate();
  }
  selectItem(item) {
    this._navigate(item.id);
  }
  save() {
    this.formSetupService.saveFormTemplate(this.model).subscribe(data => {
      this.model = data;
      let idx = findIndex(this.items, {
        id: get(data, 'id')
      });
      if (idx === -1) {
        this.items.push(data);
        this.currentTemplate = get(data, 'id');
        this._navigate(this.currentTemplate);
      } else this.items[idx] = data;
    });
  }
  exit() {}
  deleteModel() {
    this.formSetupService.deleteFormTemplate(this.model.id).subscribe(data => {
      this._navigate();
    });
  }
  exportModel() {
    this.formSetupService.saveFormTemplate(this.model).subscribe(() => {
      this.formSetupService.exportFormTemplate(this.model.id, this.model.name).subscribe(download => download(), err => this.snackBar.open(this.translateService.instant('shared.download_error')));
    });
  }
  duplicateModel() {
    this.currentTemplate = null;
    this._navigate(null, this.model.id);
  }
  trackByFn(index, item) {
    return index;
  }
  checkNameUniqueness(value, c_name, data) {
    return chain(data).filter({
      name: value
    }).size().value() != 1;
  }
  duplicateBlock(block, blockIdx) {
    this.model.blocks.splice(blockIdx + 1, 0, set(cloneDeep(block), 'name', `${this.translateService.instant('form.block_name')}_${this.model.blocks.length + 1}`));
  }
  newField(block, idx) {
    if (!isNull(idx)) block.fields.splice(idx + 1, 0, cloneDeep(assignIn(this.defaultField, {
      name: `${this.translateService.instant('form.field_name')}_${size(block.fields) + 1}`
    })));else block.fields.unshift(cloneDeep(assignIn(this.defaultField, {
      name: `${this.translateService.instant('form.field_name')}_${size(block.fields) + 1}`
    })));
  }
  addPictureField(block, files, idx = null) {
    if (!isNull(idx)) block.fields.splice(idx + 1, 0, assignIn(cloneDeep(this.defaultField), {
      type: 'image',
      name: `${this.translateService.instant('form.field_name')}_${size(block.fields) + 1}`,
      config: {
        picture_style: {
          height: '100%',
          width: '100%',
          'margin-left': 'auto'
        }
      }
    }));else block.fields.unshift(assignIn(cloneDeep(this.defaultField), {
      type: 'image',
      name: `${this.translateService.instant('form.field_name')}_${size(block.fields) + 1}`,
      config: {
        picture_style: {
          height: '100%',
          width: '100%',
          'margin-left': 'auto'
        }
      }
    }));
    this.busy = this.convertToBase64(files[0]).then(data => {
      if (!isNull(idx)) block.fields[idx + 1].picture = data;else block.fields[block.fields.length - 1].picture = data;
      this.files = [];
    });
  }
  convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.readAsDataURL(file);
      r.onload = () => resolve(r.result);
      r.onerror = error => reject(error);
    });
  }
  newBlock(block) {
    let idx = findIndex(this.model.blocks, {
      name: block.name
    });
    if (idx !== -1) this.model.blocks.splice(idx + 1, 0, cloneDeep(assignIn(this.defaultBlock, {
      name: `${this.translateService.instant('form.block_name')}_${size(this.model.blocks) + 1}`
    })));else this.model.blocks.push(cloneDeep(assignIn(this.defaultBlock, {
      name: `${this.translateService.instant('form.block_name')}_${size(this.model.blocks) + 1}`
    })));
  }
  removeBlock(idx) {
    this.model.blocks.splice(idx, 1);
  }
  drop(block, event) {
    moveItemInArray(block.fields, event.previousIndex, event.currentIndex);
  }
  compareCondition(o1, o2) {
    return o1 && o2 && o1 === o2;
  }
  fieldTypeChange(f) {
    f.value = null;
    switch (f.type) {
      case 'date':
      case 'text':
      case 'long-text':
        f.options = {
          is_measurement: false,
          measurement: null
        };
        break;
      case 'checkbox':
        f.options = ['option1'];
        f.value = {};
        break;
      case 'list':
      case 'radio-button':
        f.options = ['option1'];
        break;
      case 'number':
        f.options = {
          decimals: 0,
          is_measurement: false,
          measurement: null
        };
        break;
      case 'image':
        f.config = {
          picture_style: {
            height: '100%',
            width: '100%',
            'margin-left': 'auto'
          }
        };
        break;
      case 'table-layout':
        f.options = {
          rows: [],
          columns: [],
          rowsLabel: ''
        };
        break;
      case 'formula':
        f.options = {
          formula: null
        };
        break;
    }
  }
  optionChanged(item, ev, idx) {
    item[idx] = ev;
    return item;
  }
  removeOption(field, idx) {
    pullAt(field.options, idx);
  }
  addOption(field, type) {
    switch (field.type) {
      case 'checkbox':
      case 'radio-button':
      case 'list':
        field.options.push(`${this.translateService.instant('option')}${size(field.options) + 1}`);
        break;
      case 'table-layout':
        if (type === 'columns') field.options.columns.push(`${this.translateService.instant('column')}${size(field.options.columns) + 1}`);else field.options.rows.push(`${this.translateService.instant('row')}${size(field.options.rows) + 1}`);
        break;
    }
  }
  removeOptionRow(r, idx) {
    r.splice(idx, 1);
  }
  removeOptionColumn(c, idx) {
    c.splice(idx, 1);
  }
  addChip(items, event) {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) items.push(value);
    // Clear the input value
    event.chipInput.clear();
    if (event.input) event.input.value = '';
  }
  removeItem(items, idx) {
    if (idx >= 0) items.splice(idx, 1);
  }
  addRowElement(r) {
    r.items.push({
      type: 'checkbox',
      name: `${r.name}_${this.translateService.instant('item')}_${size(r.items) + 1}`,
      options: []
    });
  }
  addTableLayoutRow(f) {
    f.options.rows.push({
      name: `${this.translateService.instant('row_item')}_${size(f.options.rows) + 1}`,
      items: [{
        type: 'checkbox',
        name: `${this.translateService.instant('row_item')}_${size(f.options.rows) + 1}_${this.translateService.instant('item')}_${1}`,
        options: []
      }]
    });
  }
  editPictureField(field, files) {
    this.busy = this.convertToBase64(files[0]).then(data => {
      field.picture = data;
      this.files = [];
    });
  }
  resetPicture(field, ev) {
    ev.stopPropagation();
    field.picture = null;
  }
  duplicateField(block, field, idx) {
    block.fields.splice(idx + 1, 0, set(cloneDeep(field), 'name', `${this.translateService.instant('form.field_name')}_${block.fields.length + 1}`));
  }
  addFieldImage(block, field, idx, files) {
    this.busy = this.convertToBase64(files[0]).then(data => {
      if (!isNull(idx)) field.picture = data;else field.picture = data;
      if (!has(field.config, 'picture_style')) field.config.picture_style = {
        height: '100%',
        width: '100%',
        'margin-left': 'auto'
      };
      this.files = [];
    });
  }
  _navigate(id, copy) {
    return this._router.navigate([], {
      queryParams: {
        id,
        copy
      },
      relativeTo: this._route,
      queryParamsHandling: 'merge'
    });
  }
  addValueRule(f, v) {
    f.config.value_rules.push({
      condition: null,
      value: f.type == 'checkbox' ? {} : null
    });
  }
  addValueChoice(vr, o, idx) {
    if (includes(vr.value, o)) vr.value.splice(idx, 1);else {
      vr.value = vr.value || [];
      vr.value.push(o);
    }
  }
  handleEditedFieldName(b, f) {
    this.editedFieldName = `${b.name}.${f.name}`;
  }
}
FormSetupComponent.ɵfac = function FormSetupComponent_Factory(t) {
  return new (t || FormSetupComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(FormSetupService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.MatSnackBar));
};
FormSetupComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: FormSetupComponent,
  selectors: [["ft-form-setup"]],
  viewQuery: function FormSetupComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(NgForm, 7);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modelForm = _t.first);
    }
  },
  inputs: {
    headerCustomTemplate: [i0.ɵɵInputFlags.None, "customTemplate", "headerCustomTemplate"]
  },
  ngContentSelectors: _c10,
  decls: 56,
  vars: 35,
  consts: [["fxLayout", "column", 1, "ft-parent-layout", "mat-elevation-z1", "ft-content-margin"], ["color", "accent"], [1, "ft-module-icon"], ["mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-view-dashboard"], ["translate", "form.form_setup"], ["fxFlex", ""], ["mat-button", "", "class", "with-icon", "accept", ".json", "ngfSelect", "", "multiple", "1", 3, "files", "filesChange", 4, "ngIf"], ["mat-button", "", 1, "with-icon", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-plus"], ["translate", "form.new"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content", "no-padding"], ["fxFlex", "", 1, "ft-content-container"], ["mode", "side", 3, "opened"], ["color", "primary"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["translate", "form.forms_list"], ["role", "list", 1, "ft-content"], ["class", "ft-empty-content", 4, "ngIf"], ["mat-list-item", "", "type", "button", 3, "disabled", "click", 4, "ngFor", "ngForOf"], ["fxLayout", "column"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content", "ft-padding"], ["fxLayout", "column", "fxFlex", "", "fxLayoutGap", "6px", "novalidate", "", 1, "ft-padding", 3, "ngBusy"], ["modelForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["matInput", "", "name", "name", "required", "", "autocomplete", "off", "minlength", "1", "tabindex", "0", "ftFieldValidation", "/api/form-template", 3, "ngModel", "placeholder", "query", "ngModelChange"], ["name", "ngModel"], ["translate", "form.already_exist", 4, "ngIf"], ["matInput", "", "name", "form_label", "required", "", "minlength", "1", "autocomplete", "off", 3, "ngModel", "placeholder", "ngModelChange"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ft-sep"], [1, "ft-actions"], ["color", "warn", "mat-mini-fab", "", 3, "matTooltip", "click", 4, "ngIf"], ["color", "primary", "mat-mini-fab", "", 3, "matTooltip", "click", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "disabled", "click"], ["type", "button", "mat-raised-button", "", "color", "warn", 3, "click"], ["FormBlocks", ""], ["mat-button", "", "accept", ".json", "ngfSelect", "", "multiple", "1", 1, "with-icon", 3, "files", "filesChange"], ["fontSet", "mdi", "fontIcon", "mdi-import"], ["translate", "form.import"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "form.no_element_to_show"], ["mat-list-item", "", "type", "button", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-pencil-box-outline", "class", "ft-success", 4, "ngIf"], ["fontSet", "mdi", "fontIcon", "mdi-pencil-box-outline", 1, "ft-success"], ["translate", "form.already_exist"], ["color", "warn", "mat-mini-fab", "", 3, "matTooltip", "click"], ["fontIcon", "mdi-delete", "fontSet", "mdi"], ["color", "primary", "mat-mini-fab", "", 3, "matTooltip", "click"], ["fontIcon", "mdi-export", "fontSet", "mdi"], ["fontIcon", "mdi-content-copy", "fontSet", "mdi"], ["fxLayout", "column", "fxLayoutAlign", "center", "fxLayoutGap", "12px", 1, "form-setup-blocks"], ["class", "blocks", "fxFlex", "noshrink", "fxLayout", "column", "fxLayoutGap", "6px", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["fxFlex", "noshrink", "fxLayout", "column", "fxLayoutGap", "6px", 1, "blocks"], ["fxFlex", "", 1, "block"], ["matInput", "", "minlength", "1", "autocomplete", "off", "required", "", 3, "name", "ngModel", "placeholder", "ngModelChange"], ["class", "ft-warning", 4, "ngIf"], ["fxFlex", "50"], ["matInput", "", "minlength", "1", "autocomplete", "off", 3, "ngModel", "placeholder", "ngModelChange"], ["matInput", "", 3, "ngModel", "placeholder", "ngModelChange"], ["fxLayout", "row", "fxLayoutAlign", "end center"], ["mat-icon-button", "", "aria-label", "drag-list", 3, "color", "matTooltip", "click"], ["fontIcon", "mdi-drag-vertical", "fontSet", "mdi"], ["mat-icon-button", "", 3, "color", "matTooltip", "click"], ["fontIcon", " mdi-drag-horizontal", "fontSet", "mdi"], ["mat-icon-button", "", 3, "color", "disabled", "matTooltip", "click"], ["fontIcon", "mdi-wrap", "fontSet", "mdi"], ["mat-icon-button", "", "color", "primary", 3, "matTooltip", "click", 4, "ngIf"], ["mat-icon-button", "", "color", "primary", 3, "matTooltip", "click"], ["mat-icon-button", "", "color", "primary", 3, "matMenuTriggerFor"], ["fontSet", "mdi", "fontIcon", "mdi-dots-vertical"], [1, "ft-small-menu"], ["blockMenu", "matMenu"], ["mat-menu-item", "", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-card-plus", "color", "primary"], ["translate", "form.add_field"], ["mat-menu-item", "", "accept", "image/*", "ngfSelect", "", "multiple", "1", 3, "files", "filesChange"], ["fontIcon", "mdi-image-plus", "fontSet", "mdi", "color", "primary"], ["translate", "form.add_image"], ["mat-menu-item", "", "aria-label", "edit", 3, "click"], ["fontIcon", "mdi-card-plus-outline", "color", "primary", "fontSet", "mdi"], ["translate", "form.add_block"], ["mat-menu-item", "", "aria-label", "edit event", 3, "click", 4, "ngIf"], ["fxFlex", "", "cdkDropList", "", 3, "cdkDropListDropped", 4, "ngIf"], [1, "ft-warning"], ["fontIcon", "mdi-arrow-expand-all", "fontSet", "mdi"], ["fontIcon", "mdi-arrow-collapse-all", "fontSet", "mdi"], ["mat-menu-item", "", "aria-label", "edit event", 3, "click"], ["fontIcon", "mdi-delete", "fontSet", "mdi", "color", "warn"], ["translate", "form.delete"], ["fxFlex", "", "cdkDropList", "", 3, "cdkDropListDropped"], ["class", "block-field", "cdkDrag", "", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["cdkDrag", "", 1, "block-field"], ["fxLayoutAlign", "center", 1, "form-block-header"], ["mat-icon-button", "", "aria-label", "drag-list"], ["fontIcon", "mdi-drag-horizontal", "fontSet", "mdi"], ["fxLayout", "column wrap"], ["matInput", "", "minlength", "1", 3, "placeholder", "name", "ngModel", "ngModelChange", "change"], [3, "ngModel", "compareWith", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["color", "primary", "fxFlex", "nogrow", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["mat-icon-button", "", "color", "accent", "accept", "image/*", "ngfSelect", "", "multiple", "1", 3, "files", "matTooltip", "filesChange", 4, "ngIf"], ["fieldMenu", "matMenu"], ["fontIcon", "mdi-card-plus", "fontSet", "mdi", "color", "primary"], ["mat-menu-item", "", "accept", "'image/*'", "ngfSelect", "", "multiple", "1", 3, "files", "filesChange"], ["fontIcon", "mdi-image-plus", "color", "primary", "fontSet", "mdi"], [3, "value"], ["multi", "", 1, "field-rules"], ["expanded", "true"], ["matInput", "", "autocomplete", "off", 3, "ngModel", "placeholder", "ngModelChange"], ["fxFlex", "", 4, "ngIf"], ["fxLayout", "row", 4, "ngIf"], ["fxLayout", "column", "fxFlex", "", 4, "ngIf"], ["fxLayout", "column", 4, "ngIf"], ["fxLayout", "row", "fxFlex", "", 4, "ngIf"], ["matInput", "", "placeholder", "Css-Classes", 3, "ngModel", "ngModelChange"], ["matInput", "", "placeholder", "Css", 3, "ngModel", "rows", "ngModelChange"], [3, "opened", "closed"], ["matInput", "", "placeholder", "Condition", 3, "ngModel", "rows", "ngModelChange"], [3, "opened", "closed", 4, "ngIf"], ["matInput", "", "type", "number", 3, "ngModel", "placeholder", "ngModelChange"], ["translate", "form.measurements"], [3, "value", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["fxLayout", "row"], ["fxLayout", "column", "fxFlex", ""], ["floatLabel", "never", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["floatLabel", "never"], ["matInput", "", "minlength", "1", "readonly", "", 3, "placeholder", "click"], ["matInput", "", 3, "ngModel", "ngModelChange"], ["mat-icon-button", "", "matSuffix", "", "color", "warn", 3, "click"], ["fontIcon", "mdi-close", "fontSet", "mdi"], ["fxLayout", "row", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["matInput", "", "minlength", "1", 3, "ngModel", "ngModelChange"], ["matSuffix", "", "mat-icon-button", "", "color", "warn", "aria-label", "cancel", 3, "click"], ["fxFlex", "", "fxLayout", "column", 1, "rows-field-set"], ["fxLayout", "row", "fxFlex", "", "fxLayoutGap", "6px", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["fxLayout", "row", "fxLayoutAlign", "center center", "fxFlex", "nogrow"], ["mat-icon-button", "", "color", "warn", 3, "click"], ["fxLayout", "row", "fxFlex", "", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["translate", "form.type"], [3, "ngModel", "ngModelChange"], ["fxFlex", "", "fxLayout", "row", "fxLayoutGap", "6px"], ["translate", "form.position"], ["fxFlex", "nogrow", "ngfDrop", "", "accept", "image/*", "ngfSelect", "", "multiple", "1", 3, "ngClass", "files", "filesChange"], ["class", "upload-box-label", "fxFlex", "", "fxLayoutAlign", "center center", "fxLayout", "column", 4, "ngIf"], ["fxLayoutAlign", "center center"], [3, "src", 4, "ngIf"], ["matSuffix", "", "color", "warn", "mat-icon-button", "", "class", "remove-picture", 3, "click", 4, "ngIf"], ["fxFlex", "", "fxLayoutAlign", "center center", "fxLayout", "column", 1, "upload-box-label"], ["translate", "form.drag_and_drop_or_click"], ["fontIcon", "mdi-cloud-upload", "fontSet", "mdi"], [3, "src"], ["matSuffix", "", "color", "warn", "mat-icon-button", "", 1, "remove-picture", 3, "click"], ["fxLayout", "row", "fxFlex", ""], ["class", "ft-empty-content", "fxLayoutAlign", "center", 4, "ngIf"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], ["mat-mini-fab", "", "color", "primary", 3, "matTooltip", "click"], ["fontIcon", "mdi-playlist-plus", "fontSet", "mdi"], ["fxLayoutAlign", "center", 1, "ft-empty-content"], [3, "ngSwitch"], ["required", "", "matInput", "", 3, "ngModel", "placeholder", "ngModelChange"], [3, "ngSwitchCase"], ["fxFlex", "", 4, "ngSwitchCase"], ["fxFlex", "", "fxLayout", "column"], ["fxFlex", "", "fxLayout", "row", "fxLayoutGap", "8px"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["color", "primary", 3, "ngModel", "ngModelChange"], ["fxFlex", "", "floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], [3, "ngModel", "fxLayout", "ngModelChange"], [1, "mn-datepicker-container"], ["matInput", "", 3, "placeholder", "matDatepicker", "ngModel", "ngModelChange"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", "", "fontSet", "mdi", "fontIcon", "mdi-calendar-today"], ["f_date", ""], ["color", "primary", "fxFlex", "nogrow", 3, "ngModel", "ngModelChange"], ["translate", "form.required"], ["translate", "form.has_border"], ["mat-icon-button", "", "color", "accent", "accept", "image/*", "ngfSelect", "", "multiple", "1", 3, "files", "matTooltip", "filesChange"], ["fontIcon", "mdi-image-plus", "fontSet", "mdi"]],
  template: function FormSetupComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "div", 0)(1, "mat-toolbar", 1)(2, "div", 2)(3, "button", 3);
      i0.ɵɵelement(4, "mat-icon", 4);
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(5, "h2", 5)(6, "span", 6);
      i0.ɵɵtemplate(7, FormSetupComponent_button_7_Template, 3, 1, "button", 7);
      i0.ɵɵelementStart(8, "button", 8);
      i0.ɵɵlistener("click", function FormSetupComponent_Template_button_click_8_listener() {
        return ctx.handleNew();
      });
      i0.ɵɵelement(9, "mat-icon", 9)(10, "span", 10);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(11, "div", 11)(12, "mat-drawer-container", 12)(13, "mat-drawer", 13)(14, "mat-toolbar", 14)(15, "div", 2);
      i0.ɵɵelement(16, "mat-icon", 15);
      i0.ɵɵelementEnd();
      i0.ɵɵelement(17, "h2", 16)(18, "span", 6);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(19, "mat-action-list", 17);
      i0.ɵɵtemplate(20, FormSetupComponent_div_20_Template, 3, 0, "div", 18)(21, FormSetupComponent_button_21_Template, 5, 3, "button", 19);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(22, "mat-drawer-content", 20)(23, "div", 21)(24, "form", 22, 23)(26, "div", 24)(27, "mat-form-field", 6)(28, "input", 25, 26);
      i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_Template_input_ngModelChange_28_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.model.name, $event) || (ctx.model.name = $event);
        return $event;
      });
      i0.ɵɵpipe(30, "translate");
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(31, FormSetupComponent_mat_error_31_Template, 1, 0, "mat-error", 27);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(32, "mat-form-field", 6)(33, "input", 28);
      i0.ɵɵtwoWayListener("ngModelChange", function FormSetupComponent_Template_input_ngModelChange_33_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.model.label, $event) || (ctx.model.label = $event);
        return $event;
      });
      i0.ɵɵpipe(34, "translate");
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(35, "div");
      i0.ɵɵprojection(36);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(37, "div");
      i0.ɵɵtemplate(38, FormSetupComponent_ng_container_38_Template, 1, 0, "ng-container", 29);
      i0.ɵɵelementEnd();
      i0.ɵɵelement(39, "hr", 30);
      i0.ɵɵtemplate(40, FormSetupComponent_ng_container_40_Template, 1, 0, "ng-container", 29);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(41, "div", 31);
      i0.ɵɵtemplate(42, FormSetupComponent_button_42_Template, 3, 3, "button", 32)(43, FormSetupComponent_button_43_Template, 3, 3, "button", 33)(44, FormSetupComponent_button_44_Template, 3, 3, "button", 33);
      i0.ɵɵelement(45, "span", 6);
      i0.ɵɵelementStart(46, "button", 34);
      i0.ɵɵlistener("click", function FormSetupComponent_Template_button_click_46_listener() {
        return ctx.save();
      });
      i0.ɵɵelementStart(47, "span");
      i0.ɵɵtext(48);
      i0.ɵɵpipe(49, "translate");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(50, "button", 35);
      i0.ɵɵlistener("click", function FormSetupComponent_Template_button_click_50_listener() {
        return ctx.exit();
      });
      i0.ɵɵelementStart(51, "span");
      i0.ɵɵtext(52);
      i0.ɵɵpipe(53, "translate");
      i0.ɵɵelementEnd()()()()()()();
      i0.ɵɵtemplate(54, FormSetupComponent_ng_template_54_Template, 2, 2, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      const _r3 = i0.ɵɵreference(25);
      const _r4 = i0.ɵɵreference(29);
      const _r12 = i0.ɵɵreference(55);
      i0.ɵɵadvance(7);
      i0.ɵɵproperty("ngIf", !(ctx.model == null ? null : ctx.model.id));
      i0.ɵɵadvance();
      i0.ɵɵproperty("disabled", !(ctx.model == null ? null : ctx.model.id));
      i0.ɵɵadvance(5);
      i0.ɵɵproperty("opened", true);
      i0.ɵɵadvance(7);
      i0.ɵɵproperty("ngIf", !ctx.items || ctx.items.length === 0);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngForOf", ctx.items);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngBusy", ctx.busy);
      i0.ɵɵadvance(4);
      i0.ɵɵtwoWayProperty("ngModel", ctx.model.name);
      i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(30, 22, "form.identifier"))("query", i0.ɵɵpureFunction0(30, _c7));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", _r4 == null ? null : _r4.errors == null ? null : _r4.errors.exists);
      i0.ɵɵadvance(2);
      i0.ɵɵtwoWayProperty("ngModel", ctx.model.label);
      i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 24, "form.title"));
      i0.ɵɵadvance(5);
      i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplateContent)("ngTemplateOutletContext", i0.ɵɵpureFunction1(31, _c8, ctx.model));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngTemplateOutlet", _r12)("ngTemplateOutletContext", i0.ɵɵpureFunction1(33, _c9, ctx.model == null ? null : ctx.model.blocks));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("disabled", _r3.invalid);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(49, 26, "form.save"));
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(53, 28, "form.exit"));
    }
  },
  dependencies: [i1$3.NgClass, i1$3.NgForOf, i1$3.NgIf, i1$3.NgTemplateOutlet, i1$3.NgSwitch, i1$3.NgSwitchCase, i2$1.ɵNgNoValidate, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.MinLengthValidator, i2$1.NgModel, i2$1.NgForm, i1$2.TranslateDirective, i3$1.MatOption, i8.MatButton, i9.MatCard, i9.MatCardContent, i9.MatCardActions, i5.MatCheckbox, i11.MatDatepicker, i11.MatDatepickerInput, i11.MatDatepickerToggle, i11.MatDatepickerToggleIcon, i12.MatAccordion, i12.MatExpansionPanel, i12.MatExpansionPanelHeader, i12.MatExpansionPanelTitle, i1$4.MatIcon, i14.MatError, i14.MatFormField, i14.MatHint, i14.MatLabel, i14.MatSuffix, i15.MatInput, i16.MatList, i16.MatListItem, i17.MatMenu, i17.MatMenuItem, i17.MatMenuTrigger, i18.MatRadioGroup, i18.MatRadioButton, i19.MatSelect, i20.MatDrawer, i20.MatDrawerContainer, i20.MatDrawerContent, i21.MatSlideToggle, i22.MatToolbar, i23.MatTooltip, i24.DefaultLayoutDirective, i24.DefaultLayoutGapDirective, i24.DefaultLayoutAlignDirective, i24.DefaultFlexDirective, i15$1.DefaultClassDirective, i26.CdkDropList, i26.CdkDrag, i27.NgBusyDirective, i28.ngfDrop, i28.ngfSelect, FieldValidationDirective, i1$2.TranslatePipe],
  styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}.value-rules[_ngcontent-%COMP%]{justify-content:center}.field-rules[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:none;margin:0 -16px;border-bottom:1px solid #e6e2e2}.field-rules[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]:first-of-type{border-top:1px solid #e6e2e2}.field-rules[_ngcontent-%COMP%]   .mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:var(--ft-primary-color)}"]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSetupComponent, [{
    type: Component,
    args: [{
      selector: 'ft-form-setup',
      template: "<div class=\"ft-parent-layout mat-elevation-z1 ft-content-margin\" fxLayout=\"column\">\n  <mat-toolbar color=\"accent\">\n    <div class=\"ft-module-icon\">\n      <button mat-icon-button>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-view-dashboard\"></mat-icon>\n      </button>\n    </div>\n    <h2 translate=\"form.form_setup\"></h2>\n    <span fxFlex></span>\n    <button\n      mat-button\n      class=\"with-icon\"\n      *ngIf=\"!model?.id\"\n      accept=\".json\"\n      ngfSelect\n      multiple=\"1\"\n      [(files)]=\"files\"\n      (filesChange)=\"handleImport($event)\"\n    >\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-import\"></mat-icon>\n      <span translate=\"form.import\"></span>\n    </button>\n    <button mat-button class=\"with-icon\" (click)=\"handleNew()\" [disabled]=\"!model?.id\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-plus\"></mat-icon>\n      <span translate=\"form.new\"></span>\n    </button>\n  </mat-toolbar>\n  <div fxFlex fxLayout=\"column\" class=\"ft-content no-padding\">\n    <mat-drawer-container class=\"ft-content-container\" fxFlex>\n      <mat-drawer mode=\"side\" [opened]=\"true\">\n        <mat-toolbar color=\"primary\">\n          <div class=\"ft-module-icon\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n          </div>\n          <h2 translate=\"form.forms_list\"></h2>\n          <span fxFlex></span>\n        </mat-toolbar>\n        <mat-action-list role=\"list\" class=\"ft-content\">\n          <div *ngIf=\"!items || items.length === 0\" class=\"ft-empty-content\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n            <span translate=\"form.no_element_to_show\"></span>\n          </div>\n          <button mat-list-item *ngFor=\"let item of items\"\n                  type=\"button\"\n                  (click)=\"selectItem(item)\"\n                  [disabled]=\"item?.id === model?.id\"\n          >\n            <mat-icon\n              fontSet=\"mdi\"\n              fontIcon=\"mdi-view-dashboard\"\n            ></mat-icon>\n            <span fxFlex>{{ item?.name }}</span>\n\n            <mat-icon\n              *ngIf=\"item?.id === model?.id\"\n              fontSet=\"mdi\"\n              fontIcon=\"mdi-pencil-box-outline\"\n              class=\"ft-success\"\n            >\n            </mat-icon>\n          </button>\n\n        </mat-action-list>\n      </mat-drawer>\n      <mat-drawer-content fxLayout=\"column\">\n        <div fxFlex fxLayout=\"column\" class=\"ft-content ft-padding\">\n          <form\n            #modelForm=\"ngForm\"\n            fxLayout=\"column\"\n            fxFlex\n            class=\"ft-padding\"\n            fxLayoutGap=\"6px\"\n            [ngBusy]=\"busy\"\n            novalidate\n          >\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex>\n                <input\n                  matInput\n                  name=\"name\"\n                  [(ngModel)]=\"model.name\"\n                  [placeholder]=\"'form.identifier' | translate\"\n                  required\n                  autocomplete=\"off\"\n                  minlength=\"1\"\n                  tabindex=\"0\"\n                  #name=\"ngModel\"\n                  ftFieldValidation=\"/api/form-template\"\n                  [query]=\"{field:'name'}\"\n                />\n                <mat-error *ngIf=\"name?.errors?.exists\" translate=\"form.already_exist\"></mat-error>\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <input\n                  matInput\n                  name=\"form_label\"\n                  [(ngModel)]=\"model.label\"\n                  [placeholder]=\"'form.title' | translate\"\n                  required\n                  minlength=\"1\"\n                  autocomplete=\"off\"\n                />\n              </mat-form-field>\n            </div>\n            <div>\n              <ng-content></ng-content>\n            </div>\n            <div>\n              <ng-container *ngTemplateOutlet=\"customTemplateContent; context: {model: model}\">\n              </ng-container>\n            </div>\n            <hr class=\"ft-sep\"/>\n            <ng-container\n              *ngTemplateOutlet=\"FormBlocks; context: {blocks: model?.blocks}\"\n            ></ng-container>\n          </form>\n        </div>\n        <div class=\"ft-actions\">\n          <button color=\"warn\" mat-mini-fab (click)=\"deleteModel()\" *ngIf=\"model?.id\"\n                  [matTooltip]=\"'form.delete' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-delete\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button color=\"primary\" mat-mini-fab (click)=\"exportModel()\" *ngIf=\"model?.id\"\n                  [matTooltip]=\"'form.export' | translate\">\n            <mat-icon fontIcon=\"mdi-export\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button\n            color=\"primary\"\n            mat-mini-fab\n            (click)=\"duplicateModel()\"\n            *ngIf=\"model?.id\"\n            [matTooltip]=\"'form.duplicate' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-content-copy\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <span fxFlex></span>\n          <button\n            type=\"button\"\n            [disabled]=\"modelForm.invalid\"\n            mat-raised-button\n            color=\"primary\"\n            (click)=\"save()\"\n          >\n            <span>{{ 'form.save' | translate }}</span>\n          </button>\n          <button type=\"button\" mat-raised-button color=\"warn\" (click)=\"exit()\">\n            <span>{{ 'form.exit' | translate }}</span>\n          </button>\n        </div>\n      </mat-drawer-content>\n    </mat-drawer-container>\n  </div>\n</div>\n<ng-template let-blocks=\"blocks\" #FormBlocks>\n  <div class=\"form-setup-blocks\" fxLayout=\"column\" fxLayoutAlign=\"center\" fxLayoutGap=\"12px\">\n    <div\n      class=\"blocks\"\n      fxFlex=\"noshrink\"\n      fxLayout=\"column\"\n      fxLayoutGap=\"6px\"\n      *ngFor=\"let b of blocks; trackBy: trackByFn; let blockIdx = index\"\n    >\n      <mat-card fxFlex class=\"block\">\n        <mat-card-content fxLayout=\"column\">\n          <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n            <mat-form-field\n              [class.mat-form-field-invalid]=\"checkNameUniqueness(b.name, 'block_name_' + blockIdx, blocks)\" fxFlex>\n              <input\n                matInput\n                name=\"{{ 'block_name_' + blockIdx }}\"\n                [(ngModel)]=\"b.name\"\n                minlength=\"1\"\n                autocomplete=\"off\"\n                [placeholder]=\"'form.identifier' | translate\"\n                required\n              />\n              <mat-hint class=\"ft-warning\"\n                        *ngIf=\"checkNameUniqueness(b.name, 'block_name_' + blockIdx, blocks)\">{{\"form.name_not_unique\"| translate}}</mat-hint>\n            </mat-form-field>\n            <mat-form-field fxFlex=\"50\">\n              <input\n                matInput\n                [(ngModel)]=\"b.label\"\n                [placeholder]=\"'form.block_label' | translate\"\n                minlength=\"1\"\n                autocomplete=\"off\"\n              />\n            </mat-form-field>\n          </div>\n          <mat-form-field fxFlex>\n            <input\n              matInput\n              [(ngModel)]=\"b.config.display_rule\"\n              [placeholder]=\"'form.display_rule'|translate\"\n            />\n          </mat-form-field>\n        </mat-card-content>\n        <mat-card-actions fxLayout=\"row\" fxLayoutAlign=\"end center\">\n          <button\n            mat-icon-button\n            color=\"{{b.config.classes['layout-column'] ? 'primary' :null}}\"\n            (click)=\"\n                            b.config.classes['layout-column'] = !b.config.classes['layout-column'];\n                            b.config.classes['layout-row'] = false;\n                            b.config.classes['layout-wrap'] = false\n                        \"\n            [matTooltip]=\"'form.form_section_layout_column' | translate\"\n            aria-label=\"drag-list\"\n          >\n            <mat-icon fontIcon=\"mdi-drag-vertical\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button\n            mat-icon-button\n            color=\"{{b.config.classes['layout-row'] ? 'primary' :null}}\"\n            (click)=\"\n                            b.config.classes['layout-row'] = !b.config.classes['layout-row'];\n                            b.config.classes['layout-column'] = false\n                        \"\n            [matTooltip]=\"'form.form_section_layout_row' | translate\"\n          >\n            <mat-icon fontIcon=\" mdi-drag-horizontal\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button\n            mat-icon-button color=\"{{ b.config.classes['layout-wrap']?'primary':'accent'}}\"\n            (click)=\"b.config.classes['layout-wrap'] = !b.config.classes['layout-wrap']\"\n            [disabled]=\"!b.config.classes['layout-row']\"\n            [matTooltip]=\"'form.form_section_layout_wrap' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-wrap\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <span fxFlex></span>\n          <button\n            *ngIf=\"hiddenBlocks['block_' + blockIdx] && b.fields && b.fields.length > 0\"\n            mat-icon-button\n            color=\"primary\"\n            (click)=\"hiddenBlocks['block_' + blockIdx] = false\"\n            [matTooltip]=\"'form.expand' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-arrow-expand-all\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button\n            *ngIf=\"\n                            !hiddenBlocks['block_' + blockIdx] && b.fields && b.fields.length > 0\n                        \"\n            mat-icon-button\n            color=\"primary\"\n            (click)=\"hiddenBlocks['block_' + blockIdx] = true\"\n            [matTooltip]=\"'form.collapse' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-arrow-collapse-all\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button\n            mat-icon-button\n            color=\"primary\"\n            (click)=\"duplicateBlock(b, blockIdx)\"\n            [matTooltip]=\"'form.duplicate' | translate\"\n          >\n            <mat-icon fontIcon=\"mdi-content-copy\" fontSet=\"mdi\"></mat-icon>\n          </button>\n          <button mat-icon-button color=\"primary\" [matMenuTriggerFor]=\"blockMenu\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-dots-vertical\"></mat-icon>\n          </button>\n\n          <mat-menu #blockMenu=\"matMenu\" class=\"ft-small-menu\">\n            <button mat-menu-item (click)=\"newField(b)\">\n              <mat-icon\n                fontSet=\"mdi\"\n                fontIcon=\"mdi-card-plus\"\n                color=\"primary\"\n              ></mat-icon>\n              <span translate=\"form.add_field\"></span>\n            </button>\n            <button\n              mat-menu-item\n              accept=\"image/*\"\n              ngfSelect\n              multiple=\"1\"\n              [(files)]=\"files\"\n              (filesChange)=\"addPictureField(b, $event)\"\n            >\n              <mat-icon\n                fontIcon=\"mdi-image-plus\"\n                fontSet=\"mdi\"\n                color=\"primary\"\n              ></mat-icon>\n              <span translate=\"form.add_image\"></span>\n            </button>\n            <button mat-menu-item (click)=\"newBlock(b)\" aria-label=\"edit\">\n              <mat-icon\n                fontIcon=\"mdi-card-plus-outline\"\n                color=\"primary\"\n                fontSet=\"mdi\"\n              ></mat-icon>\n              <span translate=\"form.add_block\"></span>\n            </button>\n            <button\n              *ngIf=\"this.model.blocks.length > 1\"\n              mat-menu-item\n              (click)=\"removeBlock(blockIdx)\"\n              aria-label=\"edit event\"\n            >\n              <mat-icon fontIcon=\"mdi-delete\" fontSet=\"mdi\" color=\"warn\"></mat-icon>\n              <span translate=\"form.delete\"></span>\n            </button>\n          </mat-menu>\n        </mat-card-actions>\n      </mat-card>\n      <div\n        *ngIf=\"!hiddenBlocks['block_' + blockIdx]\"\n        fxFlex\n        cdkDropList\n        (cdkDropListDropped)=\"drop(b, $event)\"\n      >\n        <mat-card\n          class=\"block-field\"\n          *ngFor=\"let f of b['fields']; trackBy: trackByFn; let fieldIdx = index\"\n          cdkDrag\n        >\n          <div class=\"form-block-header\" fxLayoutAlign=\"center\">\n            <button mat-icon-button aria-label=\"drag-list\">\n              <mat-icon fontIcon=\"mdi-drag-horizontal\" fontSet=\"mdi\"></mat-icon>\n            </button>\n          </div>\n          <mat-card-content fxLayout=\"column wrap\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field [class.mat-form-field-invalid]=\"checkNameUniqueness(\n                                            f.name,\n                                            'field_name_' + fieldIdx,\n                                            b.fields\n                                        )\" fxFlex>\n                <input\n                  matInput\n                  [placeholder]=\"'form.identifier' | translate\"\n                  name=\"{{ 'field_name_' + fieldIdx }}\"\n                  [(ngModel)]=\"f.name\"\n                  minlength=\"1\"\n                  (change)=\"\n                                        checkNameUniqueness(\n                                            f.name,\n                                            'field_name_' + fieldIdx,\n                                            b.fields\n                                        )\n                                    \"\n                />\n                <mat-hint class=\"ft-warning\"\n                          *ngIf=\"checkNameUniqueness(\n                                            f.name,\n                                            'field_name_' + fieldIdx,\n                                            b.fields\n                                        )\"\n                >{{\"form.name_not_unique\"| translate}}</mat-hint>\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <mat-label>{{ 'form.type' | translate }}</mat-label>\n                <mat-select\n                  [(ngModel)]=\"f.type\"\n                  [compareWith]=\"compareCondition\"\n                  (ngModelChange)=\"fieldTypeChange(f); displayedFields['block_' + blockIdx+'_field_'+fieldIdx]=true;\"\n                >\n                  <mat-option *ngFor=\"let t of fieldTypes\" [value]=\"t\">\n                    {{ 'form.' + t | translate }}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n            </div>\n            <div *ngIf=\"displayedFields['block_' + blockIdx+'_field_'+fieldIdx]\">\n              <br>\n              <hr class=\"ft-sep\"/>\n              <br>\n              <mat-accordion class=\"field-rules\" multi>\n                <mat-expansion-panel expanded=\"true\">\n                  <mat-expansion-panel-header>\n                    <mat-panel-title>\n                      <h4>{{\"form.details\"|translate}}</h4>\n                    </mat-panel-title>\n                  </mat-expansion-panel-header>\n                  <div fxLayout=\"column wrap\">\n                    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n                      <mat-form-field fxFlex=\"50\">\n                        <input\n                          matInput\n                          [(ngModel)]=\"f.label\"\n                          [placeholder]=\"'form.field_label' | translate\"\n                          autocomplete=\"off\"\n                        />\n                      </mat-form-field>\n                      <mat-form-field fxFlex *ngIf=\"f.type === 'number'\">\n                        <input\n                          matInput\n                          [(ngModel)]=\"f.options['suffix']\"\n                          [placeholder]=\"'form.suffix' | translate\"\n                        />\n                      </mat-form-field>\n                      <mat-form-field *ngIf=\"f.type === 'number'\" fxFlex>\n                        <input\n                          matInput\n                          [(ngModel)]=\"f.options['decimals']\"\n                          type=\"number\"\n                          [placeholder]=\"'form.decimals' | translate\"\n                        />\n                      </mat-form-field>\n                      <mat-form-field\n                        fxFlex\n                        *ngIf=\"\n                                    f.options.is_measurement &&\n                                    ['date', 'text', 'long-text', 'number'].includes(f.type)\n                                \"\n                      >\n                        <label translate=\"form.measurements\"></label>\n                        <mat-select\n                          [(ngModel)]=\"f.options.measurement\"\n                          [compareWith]=\"compareCondition\"\n                        >\n                          <mat-option\n                            *ngFor=\"let m of measurements; trackBy: trackByFn\"\n                            [value]=\"m\"\n                          >\n                            {{ m.name }}\n                          </mat-option>\n                        </mat-select>\n                      </mat-form-field>\n                    </div>\n                    <div fxLayout=\"row\" *ngIf=\"f.type === 'number'\">\n                      <mat-form-field fxFlex=\"50\">\n                        <input\n                          matInput\n                          [(ngModel)]=\"f.value\"\n                          type=\"number\"\n                          [placeholder]=\"'form.default_value' | translate\"\n                        />\n                      </mat-form-field>\n                    </div>\n                    <div\n                      fxLayout=\"column\"\n                      fxFlex\n                      *ngIf=\"['checkbox', 'list', 'radio-button'].includes(f.type)\"\n                    >\n                      <mat-form-field\n                        floatLabel=\"never\"\n                        *ngFor=\"let o of f['options']; trackBy: trackByFn; let oIdx = index\"\n                      >\n                        <input\n                          matInput\n                          [ngModel]=\"o\"\n                          (ngModelChange)=\"optionChanged(f['options'], $event, oIdx)\"\n                        />\n                        <button\n                          mat-icon-button\n                          (click)=\"removeOption(f, oIdx)\"\n                          matSuffix\n                          color=\"warn\"\n                        >\n                          <mat-icon fontIcon=\"mdi-close\" fontSet=\"mdi\"></mat-icon>\n                        </button>\n                      </mat-form-field>\n\n                      <mat-form-field floatLabel=\"never\">\n                        <input\n                          matInput\n                          (click)=\"addOption(f)\"\n                          minlength=\"1\"\n                          readonly\n                          [placeholder]=\"'form.add_option' | translate\"\n                        />\n                      </mat-form-field>\n                    </div>\n                    <div fxLayout=\"column\" fxFlex *ngIf=\"f.type === 'table-layout'\">\n                      <hr class=\"ft-sep\"/>\n                      <div fxLayout=\"column\" fxFlex>\n                        <mat-form-field\n                          floatLabel=\"never\"\n                          *ngFor=\"\n                                        let c of f.options['columns'];\n                                        trackBy: trackByFn;\n                                        let cIdx = index\n                                    \"\n                        >\n                          <input\n                            matInput\n                            [ngModel]=\"c\"\n                            minlength=\"1\"\n                            (ngModelChange)=\"\n                                            optionChanged(f.options['columns'], $event, cIdx)\n                                        \"\n                          />\n                          <button\n                            matSuffix\n                            mat-icon-button\n                            color=\"warn\"\n                            (click)=\"removeOptionColumn(f.options['columns'], cIdx)\"\n                            aria-label=\"cancel\"\n                          >\n                            <mat-icon fontIcon=\"mdi-close\" fontSet=\"mdi\"></mat-icon>\n                          </button>\n                        </mat-form-field>\n                        <mat-form-field floatLabel=\"never\">\n                          <input\n                            matInput\n                            (click)=\"addOption(f, 'columns')\"\n                            minlength=\"1\"\n                            readonly\n                            [placeholder]=\"'form.add_header' | translate\"\n                          />\n                        </mat-form-field>\n                      </div>\n                      <hr class=\"ft-sep\"/>\n                      <div fxLayout=\"column\" fxFlex>\n                        <div\n                          fxLayout=\"row\"\n                          *ngFor=\"\n                                        let r of f.options['rows'];\n                                        trackBy: trackByFn;\n                                        let rIdx = index\n                                    \"\n                        >\n                          <fieldset class=\"rows-field-set\" fxFlex fxLayout=\"column\">\n                            <legend>L_{{ rIdx + 1 }}</legend>\n                            <div\n                              fxLayout=\"row\"\n                              *ngFor=\" let e of r['items'];  trackBy: trackByFn;  let iIdx = index; \"\n                              fxFlex\n                              fxLayoutGap=\"6px\"\n                            >\n                              <mat-form-field fxFlex=\"nogrow\">\n                                <mat-label translate=\"form.type\"></mat-label>\n                                <mat-select\n                                  [(ngModel)]=\"e.type\"\n                                  (ngModelChange)=\"fieldTypeChange(e)\"\n                                >\n                                  <mat-option\n                                    *ngFor=\" let t of ['radio-button','text','number','paragraph','an_empty_field'];\"\n                                    [value]=\"t\"\n                                  >\n                                    <span>{{ 'form.' + t | translate }}</span>\n                                  </mat-option>\n                                </mat-select>\n                              </mat-form-field>\n                              <mat-form-field fxFlex>\n                                <input\n                                  matInput\n                                  [(ngModel)]=\"e.label\"\n                                  [placeholder]=\"'form.field_label' | translate\"\n                                />\n                              </mat-form-field>\n\n                              <mat-form-field *ngIf=\"e.type === 'number'\" fxFlex>\n                                <input\n                                  matInput\n                                  [(ngModel)]=\"e.options['decimals']\"\n                                  type=\"number\"\n                                  [placeholder]=\"'form.decimals' | translate\"\n                                />\n                              </mat-form-field>\n                              <mat-form-field fxFlex *ngIf=\"e.type === 'text'\">\n                                <input\n                                  matInput\n                                  [(ngModel)]=\"e.options['suffix']\"\n                                  [placeholder]=\"'form.suffix' | translate\"\n                                />\n                                <button\n                                  mat-icon-button\n                                  matSuffix\n                                  color=\"warn\"\n                                  (click)=\"removeItem(r['items'], iIdx)\"\n                                >\n                                  <mat-icon\n                                    fontIcon=\"mdi-close\"\n                                    fontSet=\"mdi\"\n                                  ></mat-icon>\n                                </button>\n                              </mat-form-field>\n                            </div>\n                            <mat-form-field floatLabel=\"never\">\n                              <input\n                                matInput\n                                (click)=\"addRowElement(r)\"\n                                minlength=\"1\"\n                                readonly\n                                [placeholder]=\"'form.add_item' | translate\"\n                              />\n                            </mat-form-field>\n                          </fieldset>\n                          <div\n                            fxLayout=\"row\"\n                            fxLayoutAlign=\"center center\"\n                            fxFlex=\"nogrow\"\n                          >\n                            <button\n                              mat-icon-button\n                              color=\"warn\"\n                              (click)=\"removeItem(f.options['rows'], rIdx)\"\n                            >\n                              <mat-icon fontIcon=\"mdi-close\" fontSet=\"mdi\"></mat-icon>\n                            </button>\n                          </div>\n                        </div>\n                        <mat-form-field floatLabel=\"never\">\n                          <input\n                            matInput\n                            (click)=\"addTableLayoutRow(f)\"\n                            minlength=\"1\"\n                            readonly\n                            [placeholder]=\"'form.add_row' | translate\"\n                          />\n                        </mat-form-field>\n                      </div>\n                    </div>\n                    <div fxLayout=\"column\" *ngIf=\"f.type === 'image' || f.picture\">\n                      <hr class=\"ft-sep\"/>\n                      <div fxFlex fxLayout=\"row\" fxLayoutGap=\"6px\">\n                        <mat-form-field>\n                          <input\n                            matInput\n                            [(ngModel)]=\"f.config.picture_style.height\"\n                            [placeholder]=\"'form.height' | translate\"\n                          />\n                        </mat-form-field>\n                        <mat-form-field>\n                          <input\n                            matInput\n                            [(ngModel)]=\"f.config.picture_style.width\"\n                            [placeholder]=\"'form.width' | translate\"\n                          />\n                        </mat-form-field>\n                        <mat-form-field>\n                          <mat-label translate=\"form.position\"></mat-label>\n                          <mat-select\n                            [(ngModel)]=\"f.config.picture_style['margin-left']\"\n                            [compareWith]=\"compareCondition\"\n                          >\n                            <mat-option *ngFor=\"let t of ['unset', 'auto']\" [value]=\"t\">\n                              <span>{{ 'form.' + t | translate }}</span>\n                            </mat-option>\n                          </mat-select>\n                        </mat-form-field>\n                      </div>\n                      <div\n                        fxFlex=\"nogrow\"\n                        [ngClass]=\"{\n                                    'empty-picture-field': !f.picture,\n                                    'picture-field': !!f.picture\n                                }\"\n                        ngfDrop\n                        accept=\"image/*\"\n                        ngfSelect\n                        multiple=\"1\"\n                        [(files)]=\"files\"\n                        (filesChange)=\"editPictureField(f, $event)\"\n                      >\n                        <div\n                          class=\"upload-box-label\"\n                          fxFlex\n                          fxLayoutAlign=\"center center\"\n                          fxLayout=\"column\"\n                          *ngIf=\"!f.picture\"\n                        >\n                          <span translate=\"form.drag_and_drop_or_click\"></span>\n                          <mat-icon fontIcon=\"mdi-cloud-upload\" fontSet=\"mdi\"></mat-icon>\n                        </div>\n\n                        <div fxLayoutAlign=\"center center\">\n                          <img [src]=\"f.picture\" *ngIf=\"f.picture\"/>\n                          <button\n                            matSuffix\n                            *ngIf=\"f.picture\"\n                            color=\"warn\"\n                            mat-icon-button\n                            class=\"remove-picture\"\n                            (click)=\"resetPicture(f, $event)\"\n                          >\n                            <mat-icon fontIcon=\"mdi-close\" fontSet=\"mdi\"></mat-icon>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                    <div fxLayout=\"row\" fxFlex *ngIf=\"f.type === 'formula'\">\n                      <mat-form-field fxFlex>\n                        <input\n                          matInput\n                          [(ngModel)]=\"f.options.formula\"\n                          [placeholder]=\"'form.base_formula' | translate\"\n                        />\n                      </mat-form-field>\n                    </div>\n                  </div>\n                </mat-expansion-panel>\n                <mat-expansion-panel>\n                  <mat-expansion-panel-header>\n                    <mat-panel-title>\n                      <h4>Style</h4>\n                    </mat-panel-title>\n                  </mat-expansion-panel-header>\n                  <div fxLayout=\"column\">\n                    <mat-form-field fxFlex>\n                      <input\n                        matInput\n                        [(ngModel)]=\"f.config.classes\"\n                        placeholder=\"Css-Classes\"\n                      />\n                    </mat-form-field>\n                    <mat-form-field fxFlex>\n                                        <textarea\n                                          matInput\n                                          [(ngModel)]=\"f.config.cssStyle\"\n                                          placeholder=\"Css\"\n                                          [rows]=\"5\"\n                                        ></textarea>\n                    </mat-form-field>\n                  </div>\n                </mat-expansion-panel>\n                <mat-expansion-panel (opened)=\"displayRulesExpanded=true\" (closed)=\"displayRulesExpanded=false\">\n                  <mat-expansion-panel-header>\n                    <mat-panel-title>\n                      <h4>{{\"form.display_rule\"|translate}}</h4>\n                    </mat-panel-title>\n                  </mat-expansion-panel-header>\n                  <mat-form-field fxFlex>\n                    <textarea\n                      matInput\n                      [(ngModel)]=\"f.config.display_rule\"\n                      placeholder=\"Condition\"\n                      [rows]=\"5\"\n                    ></textarea>\n                  </mat-form-field>\n                </mat-expansion-panel>\n                <mat-expansion-panel *ngIf=\"['checkbox','radio-button','list','date'].includes(f.type)\"\n                                     (opened)=\"valueRulesExpanded=true\"\n                                     (closed)=\"valueRulesExpanded=false\">\n                  <mat-expansion-panel-header>\n                    <mat-panel-title>\n                      <h4>{{\"form.value_rules\"|translate}}</h4>\n                    </mat-panel-title>\n                  </mat-expansion-panel-header>\n                  <div *ngIf=\"!f?.config?.value_rules ||  f?.config?.value_rules.length==0\" class=\"ft-empty-content\"\n                       fxLayoutAlign=\"center\">\n                    <span translate=\"form.no_element_to_show\"></span>\n                  </div>\n                  <div>\n                    <ng-container *ngFor=\"let vr of f?.config?.value_rules ; let vIdx = index\" [ngSwitch]=\"f.type\">\n                      <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n                        <mat-form-field fxFlex>\n                          <input required\n                                 matInput\n                                 [(ngModel)]=\"vr.condition\"\n                                 [placeholder]=\"'form.condition' | translate\"\n                          />\n                          <button\n                            mat-icon-button\n                            (click)=\"removeOptionRow(f?.config?.value_rules, vIdx)\"\n                            matSuffix\n                            color=\"warn\"\n                          >\n                            <mat-icon fontIcon=\"mdi-close\" fontSet=\"mdi\"></mat-icon>\n                          </button>\n                        </mat-form-field>\n                        <ng-template [ngSwitchCase]=\"'checkbox'\">\n                          <div fxFlex fxLayout=\"column\">\n                            <span>{{ 'form.value'|translate }}</span>\n                            <div fxFlex fxLayout=\"row\" fxLayoutGap=\"8px\">\n                              <ng-container\n                                *ngFor=\"let o of f['options']; trackBy: trackByFn; let idx = index\"\n                              >\n                                <mat-checkbox\n                                  color=\"primary\"\n                                  [(ngModel)]=\"vr?.value[o]\"\n                                >\n                                  <span>{{ o }}</span>\n                                </mat-checkbox>\n                              </ng-container>\n                            </div>\n                          </div>\n                        </ng-template>\n                        <ng-template [ngSwitchCase]=\"'radio-button'\">\n                          <mat-form-field fxFlex floatLabel=\"always\" class=\"ft-radio-field\">\n                            <input matInput [placeholder]=\"f.label\" style=\"display: none\"\n                                   [placeholder]=\"'form.value'|translate\"/>\n                            <mat-radio-group\n                              [(ngModel)]=\"vr.value\"\n                              [fxLayout]=\"'row'\"\n                            >\n                              <mat-radio-button *ngFor=\"let o of f.options\" [value]=\"o\">\n                                {{ o }}\n                              </mat-radio-button>\n                            </mat-radio-group>\n                          </mat-form-field>\n                        </ng-template>\n                        <mat-form-field fxFlex *ngSwitchCase=\"'list'\">\n                          <mat-label>{{'form.value'|translate}}</mat-label>\n                          <mat-select\n                            [(ngModel)]=\"vr.value\"\n                          >\n                            <mat-option *ngFor=\"let o of f.options\" [value]=\"o\">\n                              {{ o }}\n                            </mat-option>\n                          </mat-select>\n                        </mat-form-field>\n                        <ng-template [ngSwitchCase]=\"'date'\">\n                          <div fxLayout=\"row\" fxFlex>\n                            <mat-form-field class=\"mn-datepicker-container\">\n                              <input\n                                matInput\n                                [placeholder]=\"'form.value'|translate\"\n                                [matDatepicker]=\"f_date\"\n                                [(ngModel)]=\"f.value\"\n                              />\n                              <mat-datepicker-toggle matSuffix [for]=\"f_date\">\n                                <mat-icon\n                                  matDatepickerToggleIcon\n                                  fontSet=\"mdi\"\n                                  fontIcon=\"mdi-calendar-today\"\n                                ></mat-icon>\n                              </mat-datepicker-toggle>\n                              <mat-datepicker #f_date></mat-datepicker>\n                            </mat-form-field>\n                          </div>\n                        </ng-template>\n                      </div>\n                    </ng-container>\n                  </div>\n                  <div>\n                    <span fxFlex></span>\n                    <button mat-mini-fab\n                            color=\"primary\"\n                            [matTooltip]=\"'form.add' | translate\"\n                            (click)=\"addValueRule(f,$event)\"\n                    >\n                      <mat-icon fontIcon=\"mdi-playlist-plus\" fontSet=\"mdi\"></mat-icon>\n                    </button>\n                  </div>\n                </mat-expansion-panel>\n              </mat-accordion>\n            </div>\n          </mat-card-content>\n          <mat-card-actions fxLayout=\"row\" fxLayoutAlign=\"end center\">\n            <span fxFlex></span>\n            <mat-slide-toggle\n              *ngIf=\"f.type !== 'table-layout'\"\n              color=\"primary\"\n              fxFlex=\"nogrow\"\n              [(ngModel)]=\"f.required\"\n            >\n              <span translate=\"form.required\"></span>\n            </mat-slide-toggle>\n            <mat-slide-toggle\n              *ngIf=\"f.type === 'table-layout'\"\n              color=\"primary\"\n              fxFlex=\"nogrow\"\n              [(ngModel)]=\"f.options.has_border\"\n            >\n              <span translate=\"form.has_border\"></span>\n            </mat-slide-toggle>\n            <button\n              mat-icon-button\n              color=\"primary\"\n              (click)=\"duplicateField(b, f, fieldIdx)\"\n              [matTooltip]=\"'form.duplicate' | translate\"\n            >\n              <mat-icon fontIcon=\"mdi-content-copy\" fontSet=\"mdi\"></mat-icon>\n            </button>\n            <button\n              *ngIf=\"\n                                !f.picture &&\n                                !['table-layout', 'image'].includes(f.type)\n                            \"\n              mat-icon-button\n              color=\"accent\"\n              accept=\"image/*\"\n              ngfSelect\n              multiple=\"1\"\n              [(files)]=\"files\"\n              (filesChange)=\"addFieldImage(b, f, fieldIdx, $event)\"\n              [matTooltip]=\"'form.add_image' | translate\"\n            >\n              <mat-icon fontIcon=\"mdi-image-plus\" fontSet=\"mdi\"></mat-icon>\n            </button>\n            <button *ngIf=\"!displayedFields['block_' + blockIdx+'_field_'+fieldIdx]\"\n                    (click)=\"displayedFields['block_' + blockIdx+'_field_'+fieldIdx] = true\"\n                    mat-icon-button\n                    color=\"primary\"\n                    [matTooltip]=\"'form.expand' | translate\"\n            >\n              <mat-icon fontIcon=\"mdi-arrow-expand-all\" fontSet=\"mdi\"></mat-icon>\n            </button>\n            <button *ngIf=\"displayedFields['block_' + blockIdx+'_field_'+fieldIdx]\"\n                    (click)=\"displayedFields['block_' + blockIdx+'_field_'+fieldIdx] = false\"\n                    mat-icon-button\n                    color=\"primary\"\n                    [matTooltip]=\"'form.collapse' | translate\"\n            >\n              <mat-icon fontIcon=\"mdi-arrow-collapse-all\" fontSet=\"mdi\"></mat-icon>\n            </button>\n            <button mat-icon-button color=\"primary\" [matMenuTriggerFor]=\"fieldMenu\">\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-dots-vertical\"></mat-icon>\n            </button>\n            <mat-menu #fieldMenu=\"matMenu\" class=\"ft-small-menu\">\n              <button mat-menu-item (click)=\"newField(b, fieldIdx)\">\n                <mat-icon\n                  fontIcon=\"mdi-card-plus\"\n                  fontSet=\"mdi\"\n                  color=\"primary\"\n                ></mat-icon>\n                <span translate=\"form.add_field\"></span>\n              </button>\n              <button mat-menu-item (click)=\"newBlock(b)\">\n                <mat-icon\n                  fontIcon=\"mdi-card-plus-outline\"\n                  color=\"primary\"\n                  fontSet=\"mdi\"\n                ></mat-icon>\n                <span translate=\"form.add_block\"></span>\n              </button>\n              <button\n                mat-menu-item\n                accept=\"'image/*'\"\n                ngfSelect\n                multiple=\"1\"\n                [(files)]=\"files\"\n                (filesChange)=\"addPictureField(b, $event, fieldIdx)\"\n              >\n                <mat-icon\n                  fontIcon=\"mdi-image-plus\"\n                  color=\"primary\"\n                  fontSet=\"mdi\"\n                ></mat-icon>\n                <span translate=\"form.add_image\"></span>\n              </button>\n              <button mat-menu-item (click)=\"removeItem(b['fields'], fieldIdx)\">\n                <mat-icon\n                  fontIcon=\"mdi-delete\"\n                  fontSet=\"mdi\"\n                  color=\"warn\"\n                ></mat-icon>\n                <span translate=\"form.delete\"></span>\n              </button>\n            </mat-menu>\n          </mat-card-actions>\n        </mat-card>\n      </div>\n    </div>\n  </div>\n</ng-template>\n",
      styles: [":host{height:100%;display:flex;flex-direction:column}.value-rules{justify-content:center}.field-rules .mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:none;margin:0 -16px;border-bottom:1px solid #e6e2e2}.field-rules .mat-expansion-panel:first-of-type{border-top:1px solid #e6e2e2}.field-rules .mat-expansion-panel-header-title{color:var(--ft-primary-color)}\n"]
    }]
  }], function () {
    return [{
      type: i1$2.TranslateService
    }, {
      type: FormSetupService
    }, {
      type: i3.ActivatedRoute
    }, {
      type: i3.Router
    }, {
      type: i4.MatSnackBar
    }];
  }, {
    modelForm: [{
      type: ViewChild,
      args: [NgForm, {
        static: true
      }]
    }],
    headerCustomTemplate: [{
      type: Input,
      args: ['customTemplate']
    }]
  });
})();
function parseRule(blocks, rule) {
  forEach(blocks, b => {
    forEach(b.fields, f => {
      let replacement = null;
      if (f.type == 'checkbox') {
        replacement = JSON.stringify(f.value);
      }
      if (f.type == 'radio-button' || f.type == 'list') {
        replacement = f.value;
      }
      if (f.type == 'date') {
        replacement = f.value ? moment(f.value).format('DD/MM/YYYY') : null;
      }
      rule = replace(rule, new RegExp(`\{${b.name}.${f.name}\}`, 'g'), replacement);
    });
  });
  return rule;
}
class FormBlockComponent {
  constructor() {
    this.blockChange = new EventEmitter();
    this.blockValid = new EventEmitter();
  }
  set block(b) {
    this.model = b;
    for (let i = 0; i < this.model.fields.length; i++) if (this.model.fields[i].type === 'table-layout' && this.model.fields[i].value == null) this.model.fields[i].value = Array.from({
      length: this.model.fields[i].options.rows.length
    }, (_, i) => {
      return {};
    });
  }
  set template(t) {
    this.modelTemplate = t;
  }
  ngOnInit() {
    setTimeout(() => {
      this.blockValid.emit(this.blockForm.valid);
    }, 100);
  }
  trackByFn(index, item) {
    return index;
  }
  hasFormulas() {
    return find(this.model.fields, f => {
      return !isNil(f.options.formula);
    });
  }
  calculateFormula(fd) {
    let s = fd.options.formula;
    if (s) {
      forEach(this.modelTemplate.blocks, b => {
        return forEach(b.fields, f => {
          s = replace(s, `{${b.name}.${f.name}}`, f.value);
        });
      });
      try {
        fd.value = eval(s);
      } catch (error) {
        fd.value = null;
      }
    }
  }
  calculateBlocFormula() {
    if (!isEmpty(this.model.fields)) forEach(this.model.fields, this.calculateFormula.bind(this));
  }
  checkChoice(f, o) {
    return includes(f.value, o);
  }
  addChoice(f, o, idx) {
    if (includes(f.value, o)) f.value.splice(idx, 1);else {
      f.value = f.value || [];
      f.value.push(o);
    }
  }
  getColumns(f) {
    return concat(f.options['rowsLabel'], f.options['columns']);
  }
  getElementType(f, columnIndex, rowIndex) {
    return f ? get(f.options, `rows.${rowIndex}.items.${columnIndex}.type`) : null;
  }
  getElementLabel(f, columnIndex, rowIndex) {
    return f ? get(f.options, `rows.${rowIndex}.items.${columnIndex}.label`) : null;
  }
  getElementSuffix(f, columnIndex, rowIndex) {
    return f ? get(f.options, `rows.${rowIndex}.items.${columnIndex}.options.suffix`) : null;
  }
  emitBlockChange() {
    this.handleValuesRules();
    this.blockChange.emit(this.model);
    this.blockValid.emit(this.blockForm.valid);
  }
  handleValuesRules() {
    forEach(this.modelTemplate.blocks, block => {
      forEach(block.fields, fl => {
        if (!isEmpty(fl.config.value_rules)) {
          this.handleRules(fl);
        }
      });
    });
  }
  handleRules(fl) {
    for (let ruleFormula of fl.config.value_rules) {
      let rule = parseRule(this.modelTemplate.blocks, cloneDeep(ruleFormula.condition));
      try {
        if (eval(rule)) {
          fl.value = ruleFormula.value;
        }
      } catch (e) {
        console.log('ruleFormula error');
      }
    }
  }
  handleDisplayRules(f) {
    if (!isEmpty(f.config.display_rule)) {
      let rule = parseRule(this.modelTemplate.blocks, cloneDeep(f.config.display_rule));
      try {
        return !!eval(rule);
      } catch (e) {
        return false;
      }
    } else {
      return true;
    }
  }
  handleFieldStyle(f) {
    return has(f.config, 'cssStyle') && !isNil(f.config.cssStyle) ? JSON.parse(`${f.config.cssStyle}`) : {};
  }
}
FormBlockComponent.ɵfac = function FormBlockComponent_Factory(t) {
  return new (t || FormBlockComponent)();
};
FormBlockComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: FormBlockComponent,
  selectors: [["ft-form-block"]],
  viewQuery: function FormBlockComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(NgForm, 7);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blockForm = _t.first);
    }
  },
  inputs: {
    block: "block",
    template: "template"
  },
  outputs: {
    blockChange: "blockChange",
    templateChange: "templateChange",
    blockValid: "blockValid"
  },
  decls: 6,
  vars: 4,
  consts: [["fxLayout", "column"], ["fxFlex", "nogrow", "fxLayoutAlign", "center center", "class", "block-header", 4, "ngIf"], ["fxLayout", "column", "fxFlex", ""], ["blockForm", "ngForm"], ["fxFlex", "", 1, "block-content", 3, "ngClass"], [3, "ngSwitch", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["fxFlex", "nogrow", "fxLayoutAlign", "center center", 1, "block-header"], ["fxFlex", ""], ["mat-icon-button", "", "color", "primary", 3, "matTooltip", "click", 4, "ngIf"], ["mat-icon-button", "", "color", "primary", 3, "matTooltip", "click"], ["fontIcon", " mdi-sync", "fontSet", "mdi"], [3, "ngSwitch"], ["fxLayout", "column", 3, "ngClass", "ngStyle"], [3, "ngSwitchCase"], ["fxLayout", "row", "fxFlex", "", 4, "ngIf"], ["fxLayout", "row", "fxFlex", "", 4, "ngSwitchCase"], [4, "ngIf"], ["fxLayout", "column", 4, "ngIf"], [1, "field-label"], ["fxFlex", "", "fxLayout", "row wrap", "fxLayoutGap", "8px"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["color", "primary", 3, "ngModel", "required", "name", "ngModelChange"], ["fxFlex", "", "floatLabel", "always", "class", "ft-radio-field", 4, "ngIf"], ["fxFlex", "", "floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], [3, "ngModel", "fxLayout", "name", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["fxLayout", "row", 4, "ngIf"], ["fxLayout", "row"], ["matInput", "", "type", "text", 3, "placeholder", "ngModel", "required", "name", "ngModelChange"], ["fxLayout", "row", "fxFlex", ""], ["matInput", "", 3, "ngModel", "required", "placeholder", "rows", "name", "ngModelChange"], ["matInput", "", "type", "number", 3, "ngModel", "required", "placeholder", "name", "ngModelChange"], ["matSuffix", ""], ["fxFlex", "", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "primary", 3, "matTooltip", "click"], ["fontIcon", "mdi-equal", "fontSet", "mdi"], [1, "mn-datepicker-container"], ["matInput", "", 3, "matDatepicker", "placeholder", "ngModel", "required", "name", "ngModelChange"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", "", "fontSet", "mdi", "fontIcon", "mdi-calendar-today"], ["f_date", ""], [3, "ngModel", "required", "name", "ngModelChange"], ["fxFlex", "", "fxLayout", "column", 4, "ngIf"], ["fxFlex", "", "fxLayout", "column"], ["mat-table", "", "fxFlex", "", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], [3, "matColumnDef"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", 3, "ngSwitch", 4, "matCellDef"], ["mat-header-cell", ""], ["mat-cell", "", 3, "ngSwitch"], [4, "ngSwitchCase"], ["color", "primary", 3, "ngModel", "disableRipple", "name", "ngModelChange"], ["matInput", "", "type", "text", "placeholder", "....................................................................................", 3, "placeholder", "ngModel", "name", "ngModelChange"], ["matInput", "", "type", "number", "placeholder", "......................................................................................", 3, "placeholder", "ngModel", "name", "ngModelChange"], ["mat-header-row", ""], ["mat-row", ""], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "center", 4, "ngIf"], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "center"], ["alt", "", 3, "ngStyle", "src"], [3, "ngStyle", "src", 4, "ngIf"], [3, "ngStyle", "src"]],
  template: function FormBlockComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵtemplate(1, FormBlockComponent_div_1_Template, 5, 2, "div", 1);
      i0.ɵɵelementStart(2, "form", 2, 3)(4, "div", 4);
      i0.ɵɵtemplate(5, FormBlockComponent_ng_container_5_Template, 16, 17, "ng-container", 5);
      i0.ɵɵelementEnd()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.model.label);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngClass", ctx.model == null ? null : ctx.model.config == null ? null : ctx.model.config.classes);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngForOf", ctx.model["fields"])("ngForTrackBy", ctx.trackByFn);
    }
  },
  dependencies: [i1$3.NgClass, i1$3.NgForOf, i1$3.NgIf, i1$3.NgStyle, i1$3.NgSwitch, i1$3.NgSwitchCase, i2$1.ɵNgNoValidate, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.RequiredValidator, i2$1.NgModel, i2$1.NgForm, i3$1.MatOption, i8.MatButton, i5.MatCheckbox, i5.MatCheckboxRequiredValidator, i11.MatDatepicker, i11.MatDatepickerInput, i11.MatDatepickerToggle, i11.MatDatepickerToggleIcon, i1$4.MatIcon, i14.MatFormField, i14.MatLabel, i14.MatSuffix, i15.MatInput, i18.MatRadioGroup, i18.MatRadioButton, i19.MatSelect, i12$1.MatTable, i12$1.MatHeaderCellDef, i12$1.MatHeaderRowDef, i12$1.MatColumnDef, i12$1.MatCellDef, i12$1.MatRowDef, i12$1.MatHeaderCell, i12$1.MatCell, i12$1.MatHeaderRow, i12$1.MatRow, i23.MatTooltip, i24.DefaultLayoutDirective, i24.DefaultLayoutGapDirective, i24.DefaultLayoutAlignDirective, i24.DefaultFlexDirective, i15$1.DefaultClassDirective, i15$1.DefaultStyleDirective, i1$2.TranslatePipe]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormBlockComponent, [{
    type: Component,
    args: [{
      selector: 'ft-form-block',
      template: "<div fxLayout=\"column\">\n  <div *ngIf=\"model.label\" fxFlex=\"nogrow\" fxLayoutAlign=\"center center\" class=\"block-header\">\n    <h4>{{ model.label }}</h4>\n    <span fxFlex=\"\"></span>\n    <button\n      mat-icon-button\n      color=\"primary\"\n      *ngIf=\"hasFormulas()\"\n      (click)=\"calculateBlocFormula()\"\n      [matTooltip]=\"'form.recalculate_block_fields' | translate\"\n    >\n      <mat-icon fontIcon=\" mdi-sync\" fontSet=\"mdi\"></mat-icon>\n    </button>\n  </div>\n  <form  #blockForm=\"ngForm\"\n            fxLayout=\"column\"\n            fxFlex\n          >\n          <div fxFlex class=\"block-content\" [ngClass]=\"model?.config?.classes\">\n            <ng-container *ngFor=\"let f of model['fields']; trackBy: trackByFn\" [ngSwitch]=\"f.type\">\n              <div fxLayout=\"column\" [ngClass]=\"f?.config?.classes\" [ngStyle]=\"handleFieldStyle(f)\">\n                <ng-template [ngSwitchCase]=\"'checkbox'\">\n                  <div fxLayout=\"column\" *ngIf=\"handleDisplayRules(f)\" >\n                    <span class=\"field-label\">{{ f['label'] }}</span>\n                    <div fxFlex fxLayout=\"row wrap\" fxLayoutGap=\"8px\">\n                      <ng-container\n                        *ngFor=\"let o of f['options']; trackBy: trackByFn; let idx = index\"\n                      >\n                        <mat-checkbox\n                          color=\"primary\"\n                          [(ngModel)]=\"f.value[o]\"\n                          (ngModelChange)=\"emitBlockChange()\"\n                          [required]=\"f.required\"\n                          name=\"{{   model.name + f.name }}\"\n                        >\n                          <span>{{ o }}</span>\n                        </mat-checkbox>\n                      </ng-container>\n                    </div>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'radio-button'\">\n                  <mat-form-field *ngIf=\"handleDisplayRules(f)\" fxFlex floatLabel=\"always\" class=\"ft-radio-field\">\n                    <input matInput [placeholder]=\"f.label\" style=\"display: none\"/>\n                    <mat-radio-group\n                      [(ngModel)]=\"f.value\"\n                      [fxLayout]=\"'row'\"\n                      (ngModelChange)=\"emitBlockChange()\"\n                      name=\"{{   model.name + f.name }}\"\n                    >\n                      <mat-radio-button *ngFor=\"let o of f.options\" [value]=\"o\">\n                        {{ o }}\n                      </mat-radio-button>\n                    </mat-radio-group>\n                  </mat-form-field>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'text'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxLayout=\"row\">\n                    <mat-form-field fxFlex>\n                      <input\n                        matInput\n                        type=\"text\"\n                        [placeholder]=\"f.label\"\n                        [(ngModel)]=\"f.value\"\n                        [required]=\"f.required\"\n                        (ngModelChange)=\"emitBlockChange()\"\n                        name=\"{{   model.name + f.name }}\"\n                      />\n                    </mat-form-field>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'long-text'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxLayout=\"row\" fxFlex>\n                    <mat-form-field fxFlex>\n                                    <textarea\n                                      matInput\n                                      [(ngModel)]=\"f.value\"\n                                      [required]=\"f.required\"\n                                      [placeholder]=\"f.label\"\n                                      [rows]=\"f.rows || 5\"\n                                      (ngModelChange)=\"emitBlockChange()\"\n                                      name=\"{{   model.name + f.name }}\"\n                                    ></textarea>\n                    </mat-form-field>\n                  </div>\n                </ng-template>\n                <div fxLayout=\"row\" *ngIf=\"f.type === 'number' && !f.options['suffix']\" fxFlex>\n                  <mat-form-field fxFlex>\n                    <input\n                      matInput\n                      [(ngModel)]=\"f.value\"\n                      [required]=\"f.required\"\n                      type=\"number\"\n                      [placeholder]=\"f.label\"\n                      (ngModelChange)=\"emitBlockChange()\"\n                      name=\"{{   model.name + f.name }}\"\n                    />\n                  </mat-form-field>\n                </div>\n                <div fxLayout=\"row\" fxFlex *ngIf=\"f.type === 'number' && f.options['suffix']\">\n                  <mat-form-field fxFlex>\n                    <input\n                      matInput\n                      [(ngModel)]=\"f.value\"\n                      [required]=\"f.required\"\n                      type=\"number\"\n                      [placeholder]=\"f.label\"\n                      (ngModelChange)=\"emitBlockChange()\"\n                      name=\"{{   model.name + f.name }}\"\n                    />\n                    <span matSuffix>{{ f.options['suffix'] | translate }}</span>\n                  </mat-form-field>\n                </div>\n                <div fxLayout=\"row\" fxFlex *ngSwitchCase=\"'formula'\">\n                  <mat-form-field *ngIf=\"handleDisplayRules(f)\" fxFlex>\n                    <input\n                      matInput\n                      [(ngModel)]=\"f.value\"\n                      [required]=\"f.required\"\n                      type=\"number\"\n                      [placeholder]=\"f.label\"\n                      (ngModelChange)=\"emitBlockChange()\"\n                      name=\"{{   model.name + f.name }}\"\n                    />\n                    <button\n                      matSuffix\n                      mat-icon-button\n                      type=\"button\"\n                      color=\"primary\"\n                      (click)=\"calculateFormula(f)\"\n                      [matTooltip]=\"'form.calculate' | translate\"\n                    >\n                      <mat-icon fontIcon=\"mdi-equal\" fontSet=\"mdi\"></mat-icon>\n                    </button>\n                  </mat-form-field>\n                </div>\n                <ng-template [ngSwitchCase]=\"'date'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxLayout=\"row\" fxFlex>\n                    <mat-form-field class=\"mn-datepicker-container\">\n                      <input\n                        matInput\n                        [matDatepicker]=\"f_date\"\n                        [placeholder]=\"f.label\"\n                        [(ngModel)]=\"f.value\"\n                        [required]=\"f.required\"\n                        (ngModelChange)=\"emitBlockChange()\"\n                        name=\"{{   model.name + f.name }}\"\n                      />\n                      <mat-datepicker-toggle matSuffix [for]=\"f_date\">\n                        <mat-icon\n                          matDatepickerToggleIcon\n                          fontSet=\"mdi\"\n                          fontIcon=\"mdi-calendar-today\"\n                        ></mat-icon>\n                      </mat-datepicker-toggle>\n                      <mat-datepicker #f_date></mat-datepicker>\n                    </mat-form-field>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'list'\">\n                  <mat-form-field *ngIf=\"handleDisplayRules(f)\">\n                    <mat-label>{{ f.label }}</mat-label>\n                    <mat-select\n                      [(ngModel)]=\"f.value\"\n                      [required]=\"f.required\"\n                      (ngModelChange)=\"emitBlockChange()\"\n                      name=\"{{   model.name + f.name }}\"\n                    >\n                      <mat-option *ngFor=\"let o of f.options\" [value]=\"o\">\n                        {{ o }}\n                      </mat-option>\n                    </mat-select>\n                  </mat-form-field>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'title'\">\n                  <h5 *ngIf=\"handleDisplayRules(f)\">{{ f.label }}</h5>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'table-layout'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxFlex fxLayout=\"column\">\n                    <table mat-table [dataSource]=\"f.value\" fxFlex>\n                      <ng-container\n                        [matColumnDef]=\"column\"\n                        *ngFor=\"let column of f.options['columns']; let cIdx = index\"\n                      >\n                        <th mat-header-cell *matHeaderCellDef>{{ column }}</th>\n                        <td\n                          mat-cell\n                          *matCellDef=\"let element; let eIdx = index\"\n                          [ngSwitch]=\"getElementType(f, cIdx, eIdx)\"\n                        >\n                          <ng-template [ngSwitchCase]=\"'radio-button'\">\n                            <mat-checkbox\n                              color=\"primary\"\n                              [(ngModel)]=\"element[column]\"\n                              [disableRipple]=\"true\"\n                              (ngModelChange)=\"emitBlockChange()\"\n                              name=\"{{   model.name + f.name }}\"\n                            >\n                            </mat-checkbox>\n                          </ng-template>\n                          <p *ngSwitchCase=\"'paragraph'\">\n                            {{ getElementLabel(f, cIdx, eIdx) }}\n                          </p>\n                          <ng-template [ngSwitchCase]=\"'text'\">\n                            <div fxLayout=\"row\">\n                              <input\n                                matInput\n                                type=\"text\"\n                                [placeholder]=\"getElementLabel(f, cIdx, eIdx)\"\n                                placeholder=\"....................................................................................\"\n                                [(ngModel)]=\"element[column]\"\n                                (ngModelChange)=\"emitBlockChange()\"\n                                name=\"{{   model.name + f.name }}\"\n                              />\n                              <span matSuffix>{{ getElementSuffix(f, cIdx, eIdx) }}</span>\n                            </div>\n                          </ng-template>\n                          <ng-template [ngSwitchCase]=\"'number'\">\n                            <input\n                              matInput\n                              type=\"number\"\n                              [placeholder]=\"getElementLabel(f, cIdx, eIdx)\"\n                              placeholder=\"......................................................................................\"\n                              [(ngModel)]=\"element[column]\"\n                              (ngModelChange)=\"emitBlockChange()\"\n                              name=\"{{   model.name + f.name }}\"\n                            />\n                          </ng-template>\n                        </td>\n                      </ng-container>\n\n                      <tr mat-header-row *matHeaderRowDef=\"f.options['columns']\"></tr>\n                      <tr mat-row *matRowDef=\"let row; columns: f.options['columns']\"></tr>\n                    </table>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'paragraph'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxFlex>\n                    <p>{{ f['label'] }}</p>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'image'\">\n                  <div *ngIf=\"handleDisplayRules(f)\" fxFlex fxLayout=\"row\" fxLayoutAlign=\"center\">\n                    <img [ngStyle]=\"f?.config?.picture_style\" [src]=\"f.picture\" alt=\"\"/>\n                  </div>\n                </ng-template>\n                <div  *ngIf=\"handleDisplayRules(f)\">\n                  <img\n                    *ngIf=\"f.type !== 'image' && f.picture\"\n                    [ngStyle]=\"f.config['picture_style']\"\n                    [src]=\"f.picture\"\n                  />\n                </div>\n              </div>\n            </ng-container>\n          </div>\n  </form>\n</div>\n"
    }]
  }], function () {
    return [];
  }, {
    blockForm: [{
      type: ViewChild,
      args: [NgForm, {
        static: true
      }]
    }],
    block: [{
      type: Input
    }],
    blockChange: [{
      type: Output
    }],
    template: [{
      type: Input
    }],
    templateChange: [{
      type: Output
    }],
    blockValid: [{
      type: Output
    }]
  });
})();
class FormComponent {
  constructor() {
    this.validBlocks = [];
    this.templateChange = new EventEmitter();
    this.valid = new EventEmitter();
    this.model = {};
  }
  set template(t) {
    this.model = t;
  }
  trackByFn(index, item) {
    return index;
  }
  handleChange(b, ev) {
    b = ev;
    this.templateChange.emit(this.model);
  }
  showBlock(b) {
    if (!isEmpty(b.config.display_rule)) {
      let rule = parseRule(this.model.blocks, cloneDeep(b.config.display_rule));
      try {
        return !!eval(rule);
      } catch (e) {
        return false;
      }
    } else {
      return true;
    }
  }
  handleBlockValid(blockName, valid) {
    if (valid) this.validBlocks.push(blockName);else remove(this.validBlocks, e => {
      return e == blockName;
    });
    this.valid.emit(this.validBlocks.length === this.handleDisplayedBlocks());
  }
  handleDisplayedBlocks() {
    return reduce(this.model.blocks, (acc, b) => {
      if (this.showBlock(b)) acc++;
      return acc;
    }, 0);
  }
}
FormComponent.ɵfac = function FormComponent_Factory(t) {
  return new (t || FormComponent)();
};
FormComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: FormComponent,
  selectors: [["ft-form"]],
  inputs: {
    template: "template"
  },
  outputs: {
    templateChange: "templateChange",
    valid: "valid"
  },
  decls: 5,
  vars: 1,
  consts: [["fxLayout", "column", 1, "ft-parent-layout", "mat-elevation-z1", "ft-content-margin"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content", "no-padding"], ["fxLayout", "column", "fxFlex", ""], ["modelForm", "ngForm"], [4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "block", "template", "blockChange", "blockValid", 4, "ngIf"], [3, "block", "template", "blockChange", "blockValid"]],
  template: function FormComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form", 2, 3);
      i0.ɵɵtemplate(4, FormComponent_ng_container_4_Template, 2, 2, "ng-container", 4);
      i0.ɵɵelementEnd()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.blocks);
    }
  },
  dependencies: [i1$3.NgForOf, i1$3.NgIf, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i24.DefaultLayoutDirective, i24.DefaultFlexDirective, FormBlockComponent],
  styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormComponent, [{
    type: Component,
    args: [{
      selector: 'ft-form',
      template: "<div class=\"ft-parent-layout mat-elevation-z1 ft-content-margin\" fxLayout=\"column\">\n  <div fxFlex fxLayout=\"column\" class=\"ft-content no-padding\">\n      <form  #modelForm=\"ngForm\"\n            fxLayout=\"column\"\n            fxFlex\n          >\n      <ng-container *ngIf=\"model?.blocks\">\n        <div *ngFor=\"let b of model.blocks; trackBy: trackByFn; let blockIdx = index\">\n          <ft-form-block *ngIf=\"showBlock(b)\" [block]=\"b\" (blockChange)=\"handleChange(b, $event)\" (blockValid)=\"handleBlockValid(b.name, $event)\"\n                         [template]=\"model\"></ft-form-block>\n        </div>\n      </ng-container>\n      </form>\n  </div>\n</div>\n",
      styles: [":host{height:100%;display:flex;flex-direction:column}\n"]
    }]
  }], function () {
    return [];
  }, {
    template: [{
      type: Input
    }],
    templateChange: [{
      type: Output
    }],
    valid: [{
      type: Output
    }]
  });
})();
class FormConfigService {
  constructor(_http) {
    this._http = _http;
    this.configs = {};
  }
  load() {
    return this._http.get('/api/system/').pipe(tap(data => {
      this.configs = data;
    }), map(() => true));
  }
  get appLang() {
    return get(this.configs, 'lang', 'fr');
  }
  handleConfig(data) {
    return reduce(data, (accumulator, item) => assign(accumulator, {
      [item.key]: item.value
    }), {});
  }
  get numberFraction() {
    return get(this.configs, 'number_format.fraction', 2);
  }
  get numberDecimal() {
    return get(this.configs, 'number_format.decimal', ' ');
  }
  get numberThousands() {
    return get(this.configs, 'number_format.thousands', ',');
  }
  convertTextToNumber(text, isInt) {
    if (isEmpty(text)) return null;else {
      let handledText = text.split(this.numberDecimal).join('.');
      handledText = handledText.replace(new RegExp(this.numberThousands, 'g'), '');
      return isInt ? parseInt(handledText) : parseFloat(handledText);
    }
  }
  formatNumber(amount, fix = this.numberFraction) {
    if (Number(amount) !== amount) return;
    // Fraction size
    let formattedAmount = Math.abs(amount).toFixed(fix);
    // Format numeral by locale ID
    formattedAmount = formattedAmount.split('.').join(this.numberDecimal);
    formattedAmount = formattedAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${this.numberThousands}`);
    // Format currency
    return `${Math.sign(amount) === -1 ? '-' : ''}${formattedAmount}`;
  }
  get currencyFraction() {
    return get(this.configs, 'currency.fraction', 2);
  }
}
FormConfigService.ɵfac = function FormConfigService_Factory(t) {
  return new (t || FormConfigService)(i0.ɵɵinject(i1$1.HttpClient));
};
FormConfigService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: FormConfigService,
  factory: FormConfigService.ɵfac,
  providedIn: 'root'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormConfigService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], function () {
    return [{
      type: i1$1.HttpClient
    }];
  }, null);
})();
const MATERIAL_MODULE = [BrowserAnimationsModule, MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatMomentDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatStepperModule, MatTreeModule, FlexLayoutModule, MatDividerModule];
moment.fn.toJSON = function () {
  return this.format('YYYY-MM-DD');
};
const FT_DATE_FORMATS = {
  parse: {
    dateInput: 'L'
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
const FT_TOOLTIP_DEFAULTS = {
  showDelay: 250,
  hideDelay: 100,
  touchendHideDelay: 100
};
const FT_SNACK_BAR_DEFAULTS = {
  duration: 2000,
  horizontalPosition: 'left',
  verticalPosition: 'bottom',
  panelClass: 'ft-snackbar'
};
class MaterialModule {
  constructor(matIconRegistry, service, adapter, momentAdapter) {
    matIconRegistry.registerFontClassAlias('mdi', 'mdi');
    adapter.setLocale(service.appLang);
    momentAdapter.setLocale(service.appLang);
  }
}
MaterialModule.ɵfac = function MaterialModule_Factory(t) {
  return new (t || MaterialModule)(i0.ɵɵinject(i1$4.MatIconRegistry), i0.ɵɵinject(FormConfigService), i0.ɵɵinject(i3$1.DateAdapter), i0.ɵɵinject(i4$1.MomentDateAdapter));
};
MaterialModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: MaterialModule
});
MaterialModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  providers: [MatIconRegistry, MomentDateAdapter, {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: FT_TOOLTIP_DEFAULTS
  }, {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: FT_SNACK_BAR_DEFAULTS
  }, {
    provide: MAT_DATE_FORMATS,
    useValue: FT_DATE_FORMATS
  }, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  }],
  imports: [BrowserAnimationsModule, MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatMomentDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatStepperModule, MatTreeModule, FlexLayoutModule, MatDividerModule]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaterialModule, [{
    type: NgModule,
    args: [{
      providers: [MatIconRegistry, MomentDateAdapter, {
        provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
        useValue: FT_TOOLTIP_DEFAULTS
      }, {
        provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
        useValue: FT_SNACK_BAR_DEFAULTS
      }, {
        provide: MAT_DATE_FORMATS,
        useValue: FT_DATE_FORMATS
      }, {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      }],
      exports: MATERIAL_MODULE
    }]
  }], function () {
    return [{
      type: i1$4.MatIconRegistry
    }, {
      type: FormConfigService
    }, {
      type: i3$1.DateAdapter
    }, {
      type: i4$1.MomentDateAdapter
    }];
  }, null);
})();
const routes = [{
  path: '',
  pathMatch: 'full',
  redirectTo: 'form-setup'
}, {
  path: 'form-setup',
  component: FormSetupComponent
}];
class FormRoutingModule {}
FormRoutingModule.ɵfac = function FormRoutingModule_Factory(t) {
  return new (t || FormRoutingModule)();
};
FormRoutingModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: FormRoutingModule
});
FormRoutingModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [RouterModule.forChild(routes), RouterModule]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRoutingModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forChild(routes)],
      exports: [RouterModule]
    }]
  }], null, null);
})();
class FtFormModule {}
FtFormModule.ɵfac = function FtFormModule_Factory(t) {
  return new (t || FtFormModule)();
};
FtFormModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: FtFormModule
});
FtFormModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [CommonModule, HttpClientModule, FormsModule, TranslateModule, MatProgressBarModule, MaterialModule, DragDropModule, NgBusyModule, ngfModule, FormRoutingModule]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtFormModule, [{
    type: NgModule,
    args: [{
      declarations: [FormSetupComponent, FormComponent, ProgressDialogComponent, FormBlockComponent, FieldValidationDirective],
      imports: [CommonModule, HttpClientModule, FormsModule, TranslateModule, MatProgressBarModule, MaterialModule, DragDropModule, NgBusyModule, ngfModule, FormRoutingModule],
      exports: [FormSetupComponent, FormComponent, ProgressDialogComponent, FieldValidationDirective],
      providers: []
    }]
  }], null, null);
})();
const lang$1 = {
  form_setup: 'Configuration des formulaires',
  new: 'Nouveau',
  import: 'Importer',
  forms_list: 'Liste des formulaires',
  no_element_to_show: 'Aucun élément trouvé',
  save: 'Enregistrer',
  exit: 'Quitter',
  identifier: 'Identifiant',
  title: 'Titre',
  name_not_unique: 'Nom existe déjà',
  block_label: 'Titre de section',
  field_label: 'Titre de champ',
  form_section_layout_column: 'Disposition par colonne',
  form_section_layout_row: 'Disposition par ligne',
  form_section_layout_wrap: 'Disposition avec retour',
  recalculate_block_fields: 'Recalculer tous les champs',
  expand: 'Afficher tout',
  collapse: 'Réduire',
  add_field: 'Nouveau champ',
  add_block: 'Nouvelle section',
  add_column: 'Ajouter une colonne',
  add_row: 'Ajouter une ligne',
  rows_label: 'Titre des Lignes',
  block_name: 'B',
  field_name: 'C',
  label_not_uniq: 'Titre existe déjà',
  decimals: 'Nombre de chiffres après la virgule',
  default_value: 'Valeur par défaut',
  add_image: 'Ajouter image',
  delete: 'Supprimer',
  checkbox: 'Choix multiple',
  paragraph: 'Description',
  'radio-button': 'Case à cocher',
  number: 'Zone de saisie numerique',
  list: 'Liste déroulante',
  text: 'Zone de saisie',
  'long-text': 'Zone de saisie multiligne',
  date: 'Date',
  'table-layout': 'Tableau personnalisé',
  option: 'Option',
  image: 'Image',
  formula: 'Formule de calcule',
  type: 'Type',
  suffix: 'Suffixe',
  position: 'Emplacement',
  auto: 'À droite',
  unset: 'Normale',
  add_header: 'Ajouter un en-tête',
  add_item: 'Ajouter un élément',
  row_item: 'L',
  an_empty_field: 'Champ vide',
  has_border: 'Bordure',
  loading_last_measures: 'Importer la dernière mesure',
  only_for_exam: 'Utilisation pour Compte Rendu',
  without_title: 'Sans titre',
  save_template_success: 'Template Enregistrée avec succès!',
  required: 'Obligatoire',
  options: 'Options',
  add_option: 'Ajouter une option',
  drag_and_drop_or_click: 'Glisser et déposer ou cliquer',
  base_formula: 'Formule de base',
  height: 'Longeur',
  width: 'Largeur',
  measurements: 'Mesures',
  value_rules: 'Valeur conditionnelle',
  display_rule: 'Condition d\'affichage',
  definition: 'Définition',
  add: 'Ajouter',
  condition: 'Condition',
  value: 'Valeur',
  details: 'Détails',
  duplicate: 'Dupliquer',
  export: 'Exporter',
  already_exist: 'déja existe'
};
const lang = {};

/*
 * Public API Surface of ft-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FieldValidationDirective, FormBlockComponent, FormComponent, FormConfigService, FormRoutingModule, FormSetupComponent, FormSetupService, FtFormModule, MaterialModule, ProgressDialogComponent, lang as formEnLang, lang$1 as formFrLang };
